import React, { useEffect, useMemo, useState } from "react";
import { postJson } from "./services/apiClient";
import productLogo from "./assets/logo-stampa-prodotti.jpeg";

const STORAGE_KEYS = {
  token: "token",
  user: "stampa-prodotti-user",
  tenant: "stampa-prodotti-tenant",
};

const DEFAULT_PRIMARY_COLOR = "#1e40af";
const DEFAULT_ACCENT_COLOR = "#14b8a6";
const DEFAULT_BRAND_NAME = "Stampa Prodotti";
const DEFAULT_LOCAL_LOGO_URL = "/UI/favicon.ico";
const CREDIT_RECHARGE_WHATSAPP_NUMBER = "5541996851621";
const CREDIT_RECHARGE_WHATSAPP_DISPLAY = "41 9 9685-1621";
const CREDIT_RECHARGE_EMAIL = "comercial@nvi.com.br";
const CREDIT_RECHARGE_WHATSAPP_MESSAGE = "Olá, gostaria de recarregar créditos do Stampa Prodotti.";
const CREDIT_RECHARGE_EMAIL_SUBJECT = "Recarga de créditos - Stampa Prodotti";
const ROUTES = [
  {
    key: "dashboard",
    label: "Dashboard",
    abbrev: "DB",
    eyebrow: "Visao geral operacional",
    navHint: "Indicadores e fila",
    title: "Visao geral",
    description: "Acompanhe os principais indicadores de impressao.",
    badges: ["Pendentes", "Impressas", "Alertas"],
  },
  {
    key: "usuarios",
    label: "Usuarios",
    abbrev: "US",
    eyebrow: "Gestao de acesso",
    navHint: "Perfis e bloqueios",
    title: "Usuarios",
    description: "Gerencie usuarios e permissoes de acesso.",
    badges: ["Acesso", "Permissoes", "Status"],
  },
  {
    key: "produtos",
    label: "Produtos",
    abbrev: "PR",
    eyebrow: "Catalogo",
    navHint: "Dados para etiqueta",
    title: "Produtos",
    description: "Cadastre, consulte e edite produtos.",
    badges: ["Cadastro", "Consulta", "Status"],
  },
  {
    key: "clientes",
    label: "Clientes",
    abbrev: "CL",
    eyebrow: "Base comercial",
    navHint: "Cadastro comercial",
    title: "Clientes",
    description: "Cadastre, consulte e edite clientes.",
    badges: ["Cadastro", "Consulta", "Status"],
  },
  {
    key: "impressoras",
    label: "Impressoras",
    abbrev: "IM",
    eyebrow: "Infraestrutura",
    navHint: "Equipamentos e host",
    title: "Impressoras",
    description: "Cadastre, consulte e edite impressoras.",
    badges: ["Equipamentos", "Rede", "Status"],
  },
  {
    key: "layouts",
    label: "Layouts",
    abbrev: "LY",
    eyebrow: "Layouts",
    navHint: "Etiquetas e campos",
    title: "Layouts",
    description: "Cadastre e consulte layouts de etiqueta.",
    badges: ["Etiqueta", "Campos", "Status"],
  },
  {
    key: "impressao",
    label: "Geração de Etiquetas",
    abbrev: "OP",
    eyebrow: "Fila de operacao",
    navHint: "Enviar para impressora",
    title: "Geração de Etiquetas",
    description: "Solicite a geração de etiquetas.",
    badges: ["Produto", "Layout", "Impressora"],
  },
  {
    key: "historico",
    label: "Histórico de Geração de Etiquetas",
    abbrev: "HI",
    eyebrow: "Auditoria",
    navHint: "Consulta e reimpressao",
    title: "Histórico de Geração de Etiquetas",
    description: "Consulte as etiquetas geradas e pendentes.",
    badges: ["Consulta", "Status", "Reimpressao"],
  },
  {
    key: "creditos",
    label: "Créditos",
    abbrev: "CR",
    eyebrow: "Saldo e movimentações",
    navHint: "Saldo e histórico",
    title: "Créditos",
    description: "Consulte seu saldo e as movimentações de créditos.",
    badges: ["Saldo", "Histórico", "Recarga"],
  },
  {
    key: "recarga-creditos",
    label: "Recarga de Créditos",
    abbrev: "RC",
    eyebrow: "Administração de créditos",
    navHint: "Adicionar créditos ao sistema",
    title: "Recarga de Créditos",
    description: "Adicione créditos ao saldo global do sistema.",
    badges: ["Créditos", "Pagamento", "Admin"],
    requiresAdmin: true,
    requiresProtectedAdmin: true,
  },
  {
    key: "tenant",
    label: "Tenant",
    abbrev: "TN",
    eyebrow: "Configuracao do ambiente",
    navHint: "Logo e cores globais",
    title: "Configuracao",
    description: "Ajuste os dados e as cores do ambiente.",
    badges: ["Logo", "Cores", "Status"],
    requiresAdmin: true,
  },
];

const DASHBOARD_RECENT_LIMIT = 5;

const DEFAULT_USER_FILTER = {
  Login: "",
  IsAdmin: "",
  IsBlocked: "",
  CdStatus: "",
  TermsUse: "",
};

const DEFAULT_USER_FORM = {
  IdUsuario: 0,
  Login: "",
  Senha: "",
  IsAdmin: 0,
  IsBlocked: 0,
  CdStatus: 1,
  TermsUse: 0,
};

const DEFAULT_PRODUCT_FILTER = {
  CodigoBaseProduto: "",
  CodBarras: "",
  Descricao: "",
  IdTipoProduto: "",
  CdStatus: "",
};

const DEFAULT_PRODUCT_FORM = {
  IdProduto: 0,
  CodigoExterno: "",
  CodigoBaseProduto: "",
  CodBarras: "",
  TipoCodigo: 1,
  Descricao: "",
  ShelfLife: "",
  IdTipoProduto: "",
  Peso: "",
  PrecoVenda: "",
  MarcaProduto: "",
  UnidadeMedida: "",
  PorcaoNutricional: "",
  ContemGluten: "",
  Ingredientes: "",
  CdStatus: 1,
};

const DEFAULT_CLIENT_FILTER = {
  CNPJ: "",
  RazaoSocial: "",
  NomeFantasia: "",
  EnderecoCompleto: "",
  CdStatus: "",
};

const DEFAULT_CLIENT_FORM = {
  IdCliente: 0,
  CNPJ: "",
  RazaoSocial: "",
  NomeFantasia: "",
  EnderecoCompleto: "",
  CdStatus: 1,
};

const DEFAULT_PRINTER_FILTER = {
  CodigoImpressora: "",
  NomeRede: "",
  NomeComputadorRede: "",
  Marca: "",
  Modelo: "",
  Apelido: "",
  CdStatus: "",
};

const DEFAULT_PRINTER_FORM = {
  IdImpressora: 0,
  CodigoImpressora: "",
  NomeRede: "",
  NomeComputadorRede: "",
  Marca: "",
  Modelo: "",
  Apelido: "",
  CdStatus: 1,
};

const DEFAULT_LAYOUT_FILTER = {
  CodigoLayout: "",
  Descricao: "",
  CdStatus: "",
};

const DEFAULT_LAYOUT_FORM = {
  IdLayoutImpressao: 0,
  CodigoLayout: "",
  Descricao: "",
  QtdeColunasImpressao: "",
  Altura: "",
  Largura: "",
  ZPL: "",
  CdStatus: 1,
};

const DEFAULT_PRINT_REQUEST_FORM = {
  IdProduto: "",
  IdLayoutImpressao: "",
  IdImpressora: "",
  CodLote: "",
  DtFabricacao: "",
  DtValidade: "",
  QtdeRequerida: "",
};

const DEFAULT_PRINT_HISTORY_FILTER = {
  IdProduto: "",
  IdImpressora: "",
  CdStatus: "",
  DataRequisicao: "",
};

const DEFAULT_CREDIT_HISTORY_FILTER = {
  DataInicial: "",
  DataFinal: "",
  TipoMovimento: "",
};

const DEFAULT_CREDIT_RECHARGE_FORM = {
  QtdeCredito: "",
  Observacao: "",
};

const DEFAULT_TENANT_FILTER = {
  NomeFantasia: "",
  RazaoSocial: "",
  CNPJ: "",
  NomeArquivoLogo: "",
  CorPrincipal: "",
  CorDestaque: "",
  CdStatus: "",
};

const DEFAULT_TENANT_FORM = {
  IdTenant: 0,
  NomeFantasia: "",
  RazaoSocial: "",
  CNPJ: "",
  NomeArquivoLogo: "",
  CorPrincipal: DEFAULT_PRIMARY_COLOR,
  CorDestaque: DEFAULT_ACCENT_COLOR,
  CdStatus: 1,
};

const OFFICIAL_PRODUCT_TYPES = [
  { IdTipoProduto: 1, Descricao: "Matéria-Prima" },
  { IdTipoProduto: 2, Descricao: "Semi-Acabado" },
  { IdTipoProduto: 3, Descricao: "Produto Acabado" },
];

// Os seeds versionados não confirmam este campo; o ID indicado na atividade fica centralizado aqui.
const NUTRITION_PRINT_FIELD_ID = 10;

const OFFICIAL_PRINT_FIELDS = [
  { IdCampoImpressao: 1, DescricaoCampo: "Logo do Cliente", ReplaceTag: "{{LOGOCLIENTE}}" },
  { IdCampoImpressao: 2, DescricaoCampo: "Nome Fantasia", ReplaceTag: "{{NOMEFANTASIA}}" },
  { IdCampoImpressao: 3, DescricaoCampo: "QRCode/CodBarra", ReplaceTag: "{{QRCODBARRA}}" },
  { IdCampoImpressao: 4, DescricaoCampo: "Descricao do produto", ReplaceTag: "{{DESCRICAOPRODUTO}}" },
  { IdCampoImpressao: 5, DescricaoCampo: "Lote do produto", ReplaceTag: "{{LOTEPRODUTO}}" },
  { IdCampoImpressao: 6, DescricaoCampo: "Data de validade", ReplaceTag: "{{DATADEVALIDADE}}" },
  { IdCampoImpressao: 7, DescricaoCampo: "Data Fabricacao", ReplaceTag: "{{DATAFABRICACAO}}" },
  { IdCampoImpressao: 8, DescricaoCampo: "Peso", ReplaceTag: "{{PESOPRODUTO}}" },
  { IdCampoImpressao: 9, DescricaoCampo: "Preco de Venda", ReplaceTag: "{{PRECOVENDA}}" },
  { IdCampoImpressao: NUTRITION_PRINT_FIELD_ID, DescricaoCampo: "Informação nutricional", ReplaceTag: "{{INFORMACAONUTRICIONAL}}" },
  { IdCampoImpressao: 11, DescricaoCampo: "Unidade de Medida", ReplaceTag: "{{UNIDADEMEDIDA}}" },
  { IdCampoImpressao: 12, DescricaoCampo: "Porção Nutricional", ReplaceTag: "{{PORCAONUTRICIONAL}}" },
  { IdCampoImpressao: 13, DescricaoCampo: "Informação de Glúten", ReplaceTag: "{{GLUTEN}}" },
  { IdCampoImpressao: 14, DescricaoCampo: "Ingredientes", ReplaceTag: "{{INGREDIENTES}}" },
];

function parseJwtPayload(token) {
  if (!token || token.split(".").length < 2) {
    return null;
  }

  try {
    const payload = token.split(".")[1];
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const decoded = window.atob(normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "="));
    return JSON.parse(decoded);
  } catch (error) {
    return null;
  }
}

function resolveFlag(rawValue) {
  if (rawValue === 1 || rawValue === "1" || rawValue === true || rawValue === "true") {
    return 1;
  }

  if (rawValue === 0 || rawValue === "0" || rawValue === false || rawValue === "false") {
    return 0;
  }

  return 0;
}

function pickValue(source, pascalName, camelName, fallback = null) {
  if (!source) {
    return fallback;
  }

  return source[pascalName] ?? source[camelName] ?? fallback;
}

function normalizeAuthResponse(response) {
  if (!response) {
    return null;
  }

  const source = response.Data || response.data || response.Payload || response.payload || response;

  return {
    IdUsuario: Number(pickValue(source, "IdUsuario", "idUsuario", 0)),
    Login: pickValue(source, "Login", "login", "Operador"),
    IsAdmin: resolveFlag(pickValue(source, "IsAdmin", "isAdmin", 0)),
    IsBlocked: resolveFlag(pickValue(source, "IsBlocked", "isBlocked", 0)),
    TermsUse: resolveFlag(pickValue(source, "TermsUse", "termsUse", 0)),
    DtAceiteTermo: pickValue(source, "DtAceiteTermo", "dtAceiteTermo", null),
    VersaoTermoAceito: pickValue(source, "VersaoTermoAceito", "versaoTermoAceito", null),
    CdStatus: Number(pickValue(source, "CdStatus", "cdStatus", 0)),
    JwtToken: pickValue(source, "JwtToken", "jwtToken", ""),
    Mensagem: pickValue(source, "Mensagem", "mensagem", ""),
  };
}

function getApiSource(value) {
  if (!value) {
    return null;
  }

  return value.Data || value.data || value.Payload || value.payload || value;
}

function normalizeUserDto(user) {
  const source = getApiSource(user);

  return {
    IdUsuario: Number(pickValue(source, "IdUsuario", "idUsuario", 0)),
    Login: pickValue(source, "Login", "login", ""),
    IsAdmin: resolveFlag(pickValue(source, "IsAdmin", "isAdmin", 0)),
    IsBlocked: resolveFlag(pickValue(source, "IsBlocked", "isBlocked", 0)),
    CdStatus: Number(pickValue(source, "CdStatus", "cdStatus", 0)),
    TermsUse: resolveFlag(pickValue(source, "TermsUse", "termsUse", 0)),
    DtAceiteTermo: pickValue(source, "DtAceiteTermo", "dtAceiteTermo", null),
    VersaoTermoAceito: pickValue(source, "VersaoTermoAceito", "versaoTermoAceito", null),
    DtUltAcesso: pickValue(source, "DtUltAcesso", "dtUltAcesso", null),
    DtBloqueio: pickValue(source, "DtBloqueio", "dtBloqueio", null),
    TentativasLogin: Number(pickValue(source, "TentativasLogin", "tentativasLogin", 0)),
    Mensagem: pickValue(source, "Mensagem", "mensagem", ""),
  };
}

function normalizeProductDto(product) {
  const source = getApiSource(product);
  const contemGluten = pickValue(source, "ContemGluten", "contemGluten", null);

  return {
    IdProduto: Number(pickValue(source, "IdProduto", "idProduto", 0)),
    CodigoExterno: pickValue(source, "CodigoExterno", "codigoExterno", ""),
    CodigoBaseProduto: pickValue(source, "CodigoBaseProduto", "codigoBaseProduto", ""),
    CodBarras: pickValue(source, "CodBarras", "codBarras", ""),
    TipoCodigo: Number(pickValue(source, "TipoCodigo", "tipoCodigo", 0)),
    Descricao: pickValue(source, "Descricao", "descricao", ""),
    ShelfLife: Number(pickValue(source, "ShelfLife", "shelfLife", 0)),
    IdTipoProduto: Number(pickValue(source, "IdTipoProduto", "idTipoProduto", 0)),
    Peso: pickValue(source, "Peso", "peso", null),
    PrecoVenda: pickValue(source, "PrecoVenda", "precoVenda", null),
    MarcaProduto: pickValue(source, "MarcaProduto", "marcaProduto", ""),
    UnidadeMedida: pickValue(source, "UnidadeMedida", "unidadeMedida", ""),
    PorcaoNutricional: pickValue(source, "PorcaoNutricional", "porcaoNutricional", ""),
    ContemGluten: contemGluten === null || contemGluten === undefined ? null : Number(contemGluten),
    Ingredientes: pickValue(source, "Ingredientes", "ingredientes", ""),
    CdStatus: Number(pickValue(source, "CdStatus", "cdStatus", 0)),
    DtCadastro: pickValue(source, "DtCadastro", "dtCadastro", null),
    DtUltAlteracao: pickValue(source, "DtUltAlteracao", "dtUltAlteracao", null),
    IdUsuCadastro: pickValue(source, "IdUsuCadastro", "idUsuCadastro", null),
    IdUsuUltAlteracao: pickValue(source, "IdUsuUltAlteracao", "idUsuUltAlteracao", null),
    Mensagem: pickValue(source, "Mensagem", "mensagem", ""),
  };
}

function normalizeClientDto(client) {
  const source = getApiSource(client);

  return {
    IdCliente: Number(pickValue(source, "IdCliente", "idCliente", 0)),
    CNPJ: pickValue(source, "CNPJ", "cnpj", ""),
    RazaoSocial: pickValue(source, "RazaoSocial", "razaoSocial", ""),
    NomeFantasia: pickValue(source, "NomeFantasia", "nomeFantasia", ""),
    EnderecoCompleto: pickValue(source, "EnderecoCompleto", "enderecoCompleto", ""),
    CdStatus: Number(pickValue(source, "CdStatus", "cdStatus", 0)),
    DtCadastro: pickValue(source, "DtCadastro", "dtCadastro", null),
    DtUltAlteracao: pickValue(source, "DtUltAlteracao", "dtUltAlteracao", null),
    IdUsuCadastro: pickValue(source, "IdUsuCadastro", "idUsuCadastro", null),
    IdUsuUltAlteracao: pickValue(source, "IdUsuUltAlteracao", "idUsuUltAlteracao", null),
    Mensagem: pickValue(source, "Mensagem", "mensagem", ""),
  };
}

function normalizePrinterDto(printer) {
  const source = getApiSource(printer);

  return {
    IdImpressora: Number(pickValue(source, "IdImpressora", "idImpressora", 0)),
    CodigoImpressora: pickValue(source, "CodigoImpressora", "codigoImpressora", ""),
    NomeRede: pickValue(source, "NomeRede", "nomeRede", ""),
    NomeComputadorRede: pickValue(source, "NomeComputadorRede", "nomeComputadorRede", ""),
    Marca: pickValue(source, "Marca", "marca", ""),
    Modelo: pickValue(source, "Modelo", "modelo", ""),
    Apelido: pickValue(source, "Apelido", "apelido", ""),
    CdStatus: Number(pickValue(source, "CdStatus", "cdStatus", 0)),
    DtCadastro: pickValue(source, "DtCadastro", "dtCadastro", null),
    DtUltAlteracao: pickValue(source, "DtUltAlteracao", "dtUltAlteracao", null),
    IdUsuCadastro: pickValue(source, "IdUsuCadastro", "idUsuCadastro", null),
    IdUsuUltAlteracao: pickValue(source, "IdUsuUltAlteracao", "idUsuUltAlteracao", null),
    Mensagem: pickValue(source, "Mensagem", "mensagem", ""),
  };
}

function normalizeLayoutFieldDto(field) {
  const source = getApiSource(field);

  return {
    IdLayoutImpressaoXCampos: Number(pickValue(source, "IdLayoutImpressaoXCampos", "idLayoutImpressaoXCampos", 0)),
    IdLayoutImpressao: Number(pickValue(source, "IdLayoutImpressao", "idLayoutImpressao", 0)),
    IdCampoImpressao: Number(pickValue(source, "IdCampoImpressao", "idCampoImpressao", 0)),
    DescricaoCampo: pickValue(source, "DescricaoCampo", "descricaoCampo", ""),
    ReplaceTag: pickValue(source, "ReplaceTag", "replaceTag", ""),
    Obrigatorio: resolveFlag(pickValue(source, "Obrigatorio", "obrigatorio", 0)),
    Selecionado: resolveFlag(pickValue(source, "Selecionado", "selecionado", 0)),
    OrdemExibicao: pickValue(source, "OrdemExibicao", "ordemExibicao", ""),
    CdStatus: Number(pickValue(source, "CdStatus", "cdStatus", 0)),
    Mensagem: pickValue(source, "Mensagem", "mensagem", ""),
  };
}

function buildLayoutFields(fields = [], idLayoutImpressao = 0) {
  const normalized = fields.map(normalizeLayoutFieldDto);
  const byId = new Map(normalized.map((field) => [field.IdCampoImpressao, field]));
  const officialIds = new Set(OFFICIAL_PRINT_FIELDS.map((field) => field.IdCampoImpressao));

  const mergedOfficial = OFFICIAL_PRINT_FIELDS.map((field) => {
    const current = byId.get(field.IdCampoImpressao);
    return {
      IdLayoutImpressaoXCampos: current?.IdLayoutImpressaoXCampos || 0,
      IdLayoutImpressao: current?.IdLayoutImpressao || idLayoutImpressao || 0,
      IdCampoImpressao: field.IdCampoImpressao,
      DescricaoCampo: current?.DescricaoCampo || field.DescricaoCampo,
      ReplaceTag: current?.ReplaceTag || field.ReplaceTag,
      Obrigatorio: resolveFlag(current?.Obrigatorio),
      Selecionado: resolveFlag(current?.Selecionado),
      OrdemExibicao: current?.OrdemExibicao ?? "",
      CdStatus: Number(current?.CdStatus || 1),
    };
  });

  const extraFields = normalized.filter((field) => !officialIds.has(field.IdCampoImpressao));
  return [...mergedOfficial, ...extraFields];
}

function normalizeLayoutDto(layout) {
  const source = getApiSource(layout);
  const idLayoutImpressao = Number(pickValue(source, "IdLayoutImpressao", "idLayoutImpressao", 0));
  const rawCampos = pickValue(source, "Campos", "campos", []);
  return {
    IdLayoutImpressao: idLayoutImpressao,
    CodigoLayout: pickValue(source, "CodigoLayout", "codigoLayout", ""),
    Descricao: pickValue(source, "Descricao", "descricao", ""),
    QtdeColunasImpressao: pickValue(source, "QtdeColunasImpressao", "qtdeColunasImpressao", ""),
    Altura: pickValue(source, "Altura", "altura", ""),
    Largura: pickValue(source, "Largura", "largura", ""),
    ZPL: pickValue(source, "ZPL", "zpl", ""),
    CdStatus: Number(pickValue(source, "CdStatus", "cdStatus", 0)),
    DtCadastro: pickValue(source, "DtCadastro", "dtCadastro", null),
    DtUltAlteracao: pickValue(source, "DtUltAlteracao", "dtUltAlteracao", null),
    IdUsuCadastro: pickValue(source, "IdUsuCadastro", "idUsuCadastro", null),
    IdUsuUltAlteracao: pickValue(source, "IdUsuUltAlteracao", "idUsuUltAlteracao", null),
    Mensagem: pickValue(source, "Mensagem", "mensagem", ""),
    Campos: buildLayoutFields(Array.isArray(rawCampos) ? rawCampos : [], idLayoutImpressao),
  };
}

function normalizePrintManagementDto(printRequest) {
  const source = getApiSource(printRequest);

  return {
    IdImpressao: Number(pickValue(source, "IdImpressao", "idImpressao", 0)),
    IdImpressora: Number(pickValue(source, "IdImpressora", "idImpressora", 0)),
    IdLayoutImpressao: Number(pickValue(source, "IdLayoutImpressao", "idLayoutImpressao", 0)),
    IdProduto: Number(pickValue(source, "IdProduto", "idProduto", 0)),
    IdUsuarioGeracao: Number(pickValue(source, "IdUsuarioGeracao", "idUsuarioGeracao", 0)),
    CodLote: pickValue(source, "CodLote", "codLote", ""),
    DtFabricacao: pickValue(source, "DtFabricacao", "dtFabricacao", null),
    DtValidade: pickValue(source, "DtValidade", "dtValidade", null),
    ZPL: pickValue(source, "ZPL", "zpl", ""),
    QtdeRequerida: Number(pickValue(source, "QtdeRequerida", "qtdeRequerida", 0)),
    DataRequisicao: pickValue(source, "DataRequisicao", "dataRequisicao", null),
    QtdeImpressa: Number(pickValue(source, "QtdeImpressa", "qtdeImpressa", 0)),
    DataImpressao: pickValue(source, "DataImpressao", "dataImpressao", null),
    CdStatus: Number(pickValue(source, "CdStatus", "cdStatus", 0)),
    MensagemErro: pickValue(source, "MensagemErro", "mensagemErro", ""),
    NomeRede: pickValue(source, "NomeRede", "nomeRede", ""),
    NomeComputadorRede: pickValue(source, "NomeComputadorRede", "nomeComputadorRede", ""),
  };
}

function normalizeCreditBalanceDto(balance) {
  const source = getApiSource(balance);

  return {
    SaldoCredito: pickValue(source, "SaldoCredito", "saldoCredito", null),
    CustoCreditoImpressao: pickValue(source, "CustoCreditoImpressao", "custoCreditoImpressao", null),
    Mensagem: pickValue(source, "Mensagem", "mensagem", ""),
  };
}

function normalizeProductNutritionItemDto(item) {
  const source = getApiSource(item);

  return {
    Descricao: pickValue(source, "Descricao", "descricao", "") || "",
    QuantidadePorPorcao: pickValue(source, "QuantidadePorPorcao", "quantidadePorPorcao", "") || "",
    PercentualVD: pickValue(source, "PercentualVD", "percentualVD", "") || "",
    Ordem: Number(pickValue(source, "Ordem", "ordem", 0)) || null,
  };
}

function normalizeProductNutritionDto(productNutrition) {
  const source = getApiSource(productNutrition);
  const items = pickValue(source, "Itens", "itens", []);

  return {
    IdProduto: Number(pickValue(source, "IdProduto", "idProduto", 0)),
    Itens: Array.isArray(items) ? items.map(normalizeProductNutritionItemDto) : [],
    Mensagem: pickValue(source, "Mensagem", "mensagem", "") || "",
  };
}

function createEmptyProductNutritionItem() {
  return {
    Descricao: "",
    QuantidadePorPorcao: "",
    PercentualVD: "",
    Ordem: null,
  };
}

function validateProductNutritionItems(items) {
  const normalizedItems = [];
  const descriptions = new Set();

  for (let index = 0; index < items.length; index += 1) {
    const item = items[index] || createEmptyProductNutritionItem();
    const lineNumber = index + 1;
    const descricao = String(item.Descricao ?? "").trim();
    const quantidadePorPorcao = String(item.QuantidadePorPorcao ?? "").trim();
    const percentualVD = String(item.PercentualVD ?? "").trim();

    if (!descricao && !quantidadePorPorcao && !percentualVD) {
      return { normalizedItems, error: `A linha ${lineNumber} está vazia. Preencha os campos obrigatórios ou exclua a linha.` };
    }

    if (!descricao) {
      return { normalizedItems, error: `Descrição obrigatória na linha ${lineNumber}.` };
    }

    if (!quantidadePorPorcao) {
      return { normalizedItems, error: `Quantidade por porção obrigatória na linha ${lineNumber}.` };
    }

    const descricaoNormalizada = descricao.toLocaleLowerCase("pt-BR");
    if (descriptions.has(descricaoNormalizada)) {
      return { normalizedItems, error: `Descrição nutricional duplicada: ${descricao}.` };
    }

    descriptions.add(descricaoNormalizada);
    normalizedItems.push({
      Descricao: descricao,
      QuantidadePorPorcao: quantidadePorPorcao,
      PercentualVD: percentualVD,
      Ordem: lineNumber,
    });
  }

  return { normalizedItems, error: "" };
}

function normalizeCreditHistoryDto(item) {
  const source = getApiSource(item);

  return {
    IdCreditoHistorico: Number(pickValue(source, "IdCreditoHistorico", "idCreditoHistorico", 0)),
    TipoMovimento: pickValue(source, "TipoMovimento", "tipoMovimento", ""),
    QtdeCredito: Number(pickValue(source, "QtdeCredito", "qtdeCredito", 0)),
    SaldoAnterior: pickValue(source, "SaldoAnterior", "saldoAnterior", null),
    SaldoPosterior: pickValue(source, "SaldoPosterior", "saldoPosterior", null),
    IdImpressao: pickValue(source, "IdImpressao", "idImpressao", null),
    DtMovimento: pickValue(source, "DtMovimento", "dtMovimento", null),
    Observacao: pickValue(source, "Observacao", "observacao", ""),
  };
}

function hasValidCreditBalance(creditBalance) {
  const saldoCredito = creditBalance?.SaldoCredito;

  return saldoCredito !== null && saldoCredito !== undefined && saldoCredito !== "" && Number.isInteger(Number(saldoCredito));
}

function normalizeTenantDto(tenant) {
  const source = getApiSource(tenant);

  return {
    IdTenant: Number(pickValue(source, "IdTenant", "idTenant", 0)),
    NomeFantasia: pickValue(source, "NomeFantasia", "nomeFantasia", ""),
    RazaoSocial: pickValue(source, "RazaoSocial", "razaoSocial", ""),
    CNPJ: pickValue(source, "CNPJ", "cnpj", ""),
    NomeArquivoLogo: pickValue(source, "NomeArquivoLogo", "nomeArquivoLogo", ""),
    CorPrincipal: pickValue(source, "CorPrincipal", "corPrincipal", DEFAULT_PRIMARY_COLOR),
    CorDestaque: pickValue(source, "CorDestaque", "corDestaque", DEFAULT_ACCENT_COLOR),
    CdStatus: Number(pickValue(source, "CdStatus", "cdStatus", 0)),
    DtCadastro: pickValue(source, "DtCadastro", "dtCadastro", null),
    DtUltAlteracao: pickValue(source, "DtUltAlteracao", "dtUltAlteracao", null),
    IdUsuCadastro: pickValue(source, "IdUsuCadastro", "idUsuCadastro", null),
    IdUsuUltAlteracao: pickValue(source, "IdUsuUltAlteracao", "idUsuUltAlteracao", null),
    Mensagem: pickValue(source, "Mensagem", "mensagem", ""),
  };
}

function isValidHexColor(value) {
  return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(String(value || "").trim());
}

function resolveTenantColor(value, fallback) {
  const normalized = String(value || "").trim();
  return isValidHexColor(normalized) ? normalized : fallback;
}

function normalizeHexColor(value) {
  const normalized = String(value || "").trim();
  if (!isValidHexColor(normalized)) {
    return "";
  }

  if (normalized.length === 4) {
    return `#${normalized[1]}${normalized[1]}${normalized[2]}${normalized[2]}${normalized[3]}${normalized[3]}`;
  }

  return normalized;
}

function hexToRgbChannels(value, fallback) {
  const resolved = normalizeHexColor(resolveTenantColor(value, fallback)) || normalizeHexColor(fallback);
  const safeValue = resolved.replace("#", "");
  const red = Number.parseInt(safeValue.slice(0, 2), 16);
  const green = Number.parseInt(safeValue.slice(2, 4), 16);
  const blue = Number.parseInt(safeValue.slice(4, 6), 16);
  return `${red} ${green} ${blue}`;
}

function darkenHexColor(value, amount) {
  const normalized = normalizeHexColor(value);
  if (!normalized) {
    return value;
  }

  const factor = Math.max(0, Math.min(1, 1 - amount));
  const red = Math.round(Number.parseInt(normalized.slice(1, 3), 16) * factor);
  const green = Math.round(Number.parseInt(normalized.slice(3, 5), 16) * factor);
  const blue = Math.round(Number.parseInt(normalized.slice(5, 7), 16) * factor);

  return `#${[red, green, blue].map((channel) => channel.toString(16).padStart(2, "0")).join("")}`;
}

function getTenantSocialReason(tenant) {
  return String(tenant?.RazaoSocial || "").trim() || DEFAULT_BRAND_NAME;
}

function getTenantDisplayName(tenant) {
  return String(tenant?.NomeFantasia || "").trim() || DEFAULT_BRAND_NAME;
}

function getTenantInitials(tenantName) {
  const words = String(tenantName || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (words.length === 0) {
    return "SP";
  }

  return words
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase();
}

function resolveTenantLogoUrl(nomeArquivoLogo, fallbackUrl = DEFAULT_LOCAL_LOGO_URL) {
  const normalized = String(nomeArquivoLogo || "").trim();

  if (!normalized) {
    return fallbackUrl;
  }

  if (/^https?:\/\//i.test(normalized) || normalized.startsWith("/")) {
    return normalized;
  }

  const cleaned = normalized.replace(/^UI[\\/]/i, "").replace(/^\/+/, "").replace(/\\/g, "/");
  return cleaned ? `/UI/${encodeURI(cleaned)}` : fallbackUrl;
}

function applyTenantTheme(tenant) {
  const corPrincipal = resolveTenantColor(tenant?.CorPrincipal, DEFAULT_PRIMARY_COLOR);
  const corDestaque = resolveTenantColor(tenant?.CorDestaque, DEFAULT_ACCENT_COLOR);
  const sidebarStart = darkenHexColor(corPrincipal, 0.78);
  const sidebarMid = darkenHexColor(corPrincipal, 0.44);
  const sidebarEnd = darkenHexColor(corDestaque, 0.18);
  const root = document.documentElement;

  root.style.setProperty("--primary", corPrincipal);
  root.style.setProperty("--accent", corDestaque);
  root.style.setProperty("--primary-rgb", hexToRgbChannels(corPrincipal, DEFAULT_PRIMARY_COLOR));
  root.style.setProperty("--accent-rgb", hexToRgbChannels(corDestaque, DEFAULT_ACCENT_COLOR));
  root.style.setProperty("--sidebar-start", sidebarStart);
  root.style.setProperty("--sidebar-mid", sidebarMid);
  root.style.setProperty("--sidebar-end", sidebarEnd);
}

function saveTenantTheme(tenant) {
  if (!tenant) {
    return null;
  }

  const normalized = normalizeTenantDto({
    ...tenant,
    RazaoSocial: getTenantSocialReason(tenant),
    NomeFantasia: getTenantDisplayName(tenant),
    CorPrincipal: resolveTenantColor(tenant.CorPrincipal, DEFAULT_PRIMARY_COLOR),
    CorDestaque: resolveTenantColor(tenant.CorDestaque, DEFAULT_ACCENT_COLOR),
  });

  window.localStorage.setItem(STORAGE_KEYS.tenant, JSON.stringify(normalized));
  return normalized;
}

function readStoredTenant() {
  const rawTenant = window.localStorage.getItem(STORAGE_KEYS.tenant);

  if (!rawTenant) {
    return null;
  }

  try {
    return normalizeTenantDto(JSON.parse(rawTenant));
  } catch (error) {
    window.localStorage.removeItem(STORAGE_KEYS.tenant);
    return null;
  }
}

function toNullableInt(value) {
  return value === "" || value === null || value === undefined ? null : Number(value);
}

function toNullableDecimal(value) {
  return value === "" || value === null || value === undefined ? null : Number(value);
}

function toNullableSelectFilter(value) {
  return value === "" || value === null || value === undefined ? null : Number(value);
}

function isSelectAll(value) {
  return value === "" || value === null || value === undefined;
}

function toTimestampValue(value) {
  if (!value) {
    return null;
  }

  if (value.length === 10) {
    return `${value}T00:00:00`;
  }

  return value.length === 16 ? `${value}:00` : value;
}

function formatDateOnlyValue(value) {
  if (!value) {
    return "";
  }

  return String(value).slice(0, 10);
}

function addDaysToDateValue(dateValue, days) {
  if (!dateValue || Number.isNaN(Number(days))) {
    return "";
  }

  const baseDate = new Date(`${dateValue}T00:00:00`);
  if (Number.isNaN(baseDate.getTime())) {
    return "";
  }

  baseDate.setDate(baseDate.getDate() + Number(days));
  return baseDate.toISOString().slice(0, 10);
}

function formatTimestampLabel(value) {
  if (!value) {
    return "-";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleString("pt-BR");
}

function getPrintStatusLabel(value) {
  const normalized = Number(value || 0);

  switch (normalized) {
    case 1:
      return "Pendente";
    case 2:
      return "Impressa";
    case 3:
      return "Reimpressao solicitada";
    case 4:
      return "Erro ao imprimir";
    default:
      return String(normalized || 0);
  }
}

function getDashboardStatusTone(value) {
  const normalized = Number(value || 0);

  switch (normalized) {
    case 2:
      return "success";
    case 4:
      return "danger";
    case 1:
    case 3:
      return "warning";
    default:
      return "neutral";
  }
}

function getDashboardPrintTitle(item) {
  const lote = item?.CodLote ? `Lote ${item.CodLote}` : "Sem lote informado";
  const produto = item?.IdProduto > 0 ? `Produto ${item.IdProduto}` : "Produto nao informado";

  return `${produto} - ${lote}`;
}

function getProductLabel(product) {
  if (!product) {
    return "-";
  }

  const descricao = String(product.Descricao || "").trim();
  const sku = String(product.CodigoBaseProduto || "").trim();

  if (descricao && sku) {
    return `${descricao} (${sku})`;
  }

  return descricao || sku || `Produto ${product.IdProduto}`;
}

function getProductSelectLabel(product) {
  if (!product) {
    return "-";
  }

  const descricao = String(product.Descricao || "").trim();
  return descricao || String(product.CodigoBaseProduto || "").trim() || `Produto ${product.IdProduto}`;
}

function getPrinterLabel(printer) {
  if (!printer) {
    return "-";
  }

  const apelido = String(printer.Apelido || "").trim();
  const nomeRede = String(printer.NomeRede || "").trim();

  if (apelido && nomeRede) {
    return `${apelido} (${nomeRede})`;
  }

  return apelido || nomeRede || `Impressora ${printer.IdImpressora}`;
}

function getPrinterSelectLabel(printer) {
  if (!printer) {
    return "-";
  }

  const apelido = String(printer.Apelido || "").trim();
  return apelido || String(printer.NomeRede || "").trim() || `Impressora ${printer.IdImpressora}`;
}

function getLayoutLabel(layout) {
  if (!layout) {
    return "-";
  }

  const codigo = String(layout.CodigoLayout || "").trim();
  const descricao = String(layout.Descricao || "").trim();

  if (codigo && descricao) {
    return `${codigo} - ${descricao}`;
  }

  return codigo || descricao || `Layout ${layout.IdLayoutImpressao}`;
}

function getLayoutSelectLabel(layout) {
  if (!layout) {
    return "-";
  }

  const descricao = String(layout.Descricao || "").trim();
  return descricao || String(layout.CodigoLayout || "").trim() || `Layout ${layout.IdLayoutImpressao}`;
}

function getDashboardSortTimestamp(item) {
  const source = item?.DataImpressao || item?.DataRequisicao;
  const timestamp = source ? new Date(source).getTime() : 0;
  return Number.isNaN(timestamp) ? 0 : timestamp;
}

function sumPrintQuantity(items, selector) {
  return items.reduce((total, item) => {
    const quantity = Number(selector(item) || 0);
    return total + (Number.isNaN(quantity) ? 0 : quantity);
  }, 0);
}

function getProductTypeLabel(idTipoProduto) {
  const normalized = Number(idTipoProduto || 0);
  if (normalized <= 0) {
    return "-";
  }

  const productType = OFFICIAL_PRODUCT_TYPES.find((item) => item.IdTipoProduto === normalized);
  return productType ? productType.Descricao : String(normalized);
}

function saveAuthSession(authResponse) {
  const normalized = normalizeAuthResponse(authResponse);
  if (!normalized || !normalized.JwtToken) {
    return null;
  }

  window.localStorage.setItem(STORAGE_KEYS.token, normalized.JwtToken);
  window.localStorage.setItem(STORAGE_KEYS.user, JSON.stringify(normalized));

  return normalized;
}

function clearAuthSession() {
  window.localStorage.removeItem(STORAGE_KEYS.token);
  window.localStorage.removeItem(STORAGE_KEYS.user);
}

function isTokenExpired(token) {
  const payload = parseJwtPayload(token);
  if (!payload?.exp) {
    return true;
  }

  return Date.now() >= payload.exp * 1000;
}

function readAuthSession() {
  const token = window.localStorage.getItem(STORAGE_KEYS.token);
  const rawUser = window.localStorage.getItem(STORAGE_KEYS.user);

  if (!token || !rawUser || isTokenExpired(token)) {
    clearAuthSession();
    return null;
  }

  try {
    const parsedUser = JSON.parse(rawUser);
    const normalized = normalizeAuthResponse({
      ...parsedUser,
      JwtToken: token,
    });

    const payload = parseJwtPayload(token);

    if (payload) {
      normalized.IsAdmin = resolveFlag(payload.IsAdmin ?? normalized.IsAdmin);
      normalized.TermsUse = resolveFlag(payload.TermsUse ?? normalized.TermsUse);
    }

    return normalized;
  } catch (error) {
    clearAuthSession();
    return null;
  }
}

function getRouteFromHash() {
  const route = window.location.hash.replace("#/", "").trim().toLowerCase();
  return route || "dashboard";
}

function FlagPill({ value }) {
  return (
    <span className={`status-chip ${resolveFlag(value) === 1 ? "success" : "neutral"}`}>
      {resolveFlag(value)}
    </span>
  );
}

function StatusPill({ value }) {
  return (
    <span className={`status-chip ${Number(value) === 1 ? "success" : "neutral"}`}>
      {Number(value) || 0}
    </span>
  );
}

function formatYesNo(value) {
  return resolveFlag(value) === 1 ? "Sim" : "Não";
}

function formatStatusLabel(value) {
  return Number(value) === 1 ? "Ativo" : "Cancelado";
}

function FlagValue({ value }) {
  return <span>{formatYesNo(value)}</span>;
}

function StatusValue({ value }) {
  return <span>{formatStatusLabel(value)}</span>;
}

function formatYesNoStatus(value) {
  return resolveFlag(value) === 1 ? "Sim" : "Não";
}

function normalizeLayoutFieldText(value) {
  return String(value || "").trim();
}

function CardHeader({ title, description, action, badge }) {
  return (
    <div className="card-title">
      <div className="card-copy">
        <h3>{title}</h3>
        {description ? <p>{description}</p> : null}
      </div>
      <div className="card-title-actions">
        {badge ? <span className="page-badge subtle">{badge}</span> : null}
        {action}
      </div>
    </div>
  );
}

function CreditRechargeActions({ compact = false, onOpen }) {
  return (
    <button className={`secondary-button${compact ? " compact-button" : ""}`} type="button" onClick={onOpen}>
      Recarregar créditos
    </button>
  );
}

function CreditLowBalanceWarning({ creditBalance, onRecharge }) {
  if (!hasValidCreditBalance(creditBalance) || Number(creditBalance.SaldoCredito) > 50) {
    return null;
  }

  return (
    <section className="credit-low-balance-alert" role="alert">
      <div>
        <strong>Você está com poucos créditos.</strong>
        <p>Recarregue seus créditos para evitar interrupções nas impressões.</p>
      </div>
      <CreditRechargeActions compact onOpen={onRecharge} />
    </section>
  );
}

function CreditRechargeDialog({ isOpen, onClose }) {
  if (!isOpen) {
    return null;
  }

  const whatsappUrl = `https://wa.me/${CREDIT_RECHARGE_WHATSAPP_NUMBER}?text=${encodeURIComponent(CREDIT_RECHARGE_WHATSAPP_MESSAGE)}`;
  const emailUrl = `mailto:${CREDIT_RECHARGE_EMAIL}?subject=${encodeURIComponent(CREDIT_RECHARGE_EMAIL_SUBJECT)}`;

  return (
    <div className="credit-recharge-backdrop" role="presentation">
      <section className="credit-recharge-dialog" role="dialog" aria-modal="true" aria-labelledby="credit-recharge-title">
        <div className="credit-recharge-dialog-header">
          <div>
            <span className="brand-kicker">Atendimento comercial</span>
            <h2 id="credit-recharge-title">Recarregar créditos</h2>
          </div>
          <button className="secondary-button compact-button" type="button" onClick={onClose} aria-label="Fechar opções de recarga">
            Fechar
          </button>
        </div>
        <p>Entre em contato com a NVi para adquirir novos créditos.</p>
        <div className="credit-recharge-channel-list">
          <a className="credit-recharge-channel" href={whatsappUrl} target="_blank" rel="noopener noreferrer">
            <strong>WhatsApp</strong>
            <span>{CREDIT_RECHARGE_WHATSAPP_DISPLAY}</span>
          </a>
          <a className="credit-recharge-channel" href={emailUrl}>
            <strong>E-mail</strong>
            <span>{CREDIT_RECHARGE_EMAIL}</span>
          </a>
        </div>
      </section>
    </div>
  );
}

function isCreditRelatedError(message) {
  const normalizedMessage = String(message || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

  return normalizedMessage.includes("credito") && normalizedMessage.includes("insuficiente");
}

function formatCreditMovementType(value) {
  const labels = {
    Pagamento: "Pagamento",
    Impressao: "Impressão",
    Reimpressao: "Reimpressão",
  };

  return labels[value] || value || "-";
}

function formatCreditAmount(value) {
  const amount = Number(value);
  if (!Number.isFinite(amount)) {
    return "-";
  }

  return amount > 0 ? `+${amount}` : String(amount);
}

function ProductLogoMark({ className = "product-mark" }) {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return <div className={`${className} fallback`}>SP</div>;
  }

  return (
    <img
      className={className}
      src={productLogo}
      alt="Stampa Prodotti"
      onError={() => setHasError(true)}
    />
  );
}

function BrandLogo({ logoUrl, initials, alt }) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [logoUrl]);

  if (logoUrl && !hasError) {
    return <img className="brand-logo-image" src={logoUrl} alt={alt} onError={() => setHasError(true)} />;
  }

  return <div className="brand-logo">{initials}</div>;
}

function LoginView({
  loginForm,
  isSubmitting,
  loginError,
  onChange,
  onSubmit,
  tenantName,
  tenantLogoUrl,
  tenantInitials,
  showPassword,
  onTogglePassword,
}) {
  return (
    <div className="login-shell">
      <div className="background-orb background-orb-left" />
      <div className="background-orb background-orb-right" />

      <section className="login-panel">
        <div className="login-brand-stack">
          <BrandLogo logoUrl={tenantLogoUrl} initials={tenantInitials} alt={`${tenantName} logo`} />
          <div className="login-brand-copy">
            <strong>{tenantName}</strong>
            <span>Sistema de impressao</span>
          </div>
        </div>

        <div className="login-help">
          <div>
            <strong>Acesso seguro</strong>
            <span>Use seu login e senha para entrar no sistema.</span>
          </div>
          <div>
            <strong>Termo de uso</strong>
            <span>Se necessario, o aceite sera solicitado antes de continuar.</span>
          </div>
        </div>

        <form className="login-form" onSubmit={onSubmit}>
          <label className="field-block" htmlFor="login">
            <span>Login</span>
            <input
              id="login"
              name="Login"
              type="text"
              value={loginForm.Login}
              onChange={onChange}
              autoComplete="username"
              placeholder="Informe seu login"
              disabled={isSubmitting}
            />
          </label>

          <label className="field-block" htmlFor="senha">
            <span>Senha</span>
            <div className="password-field">
              <input
                id="senha"
                name="Senha"
                type={showPassword ? "text" : "password"}
                value={loginForm.Senha}
                onChange={onChange}
                autoComplete="current-password"
                placeholder="Digite sua senha"
                disabled={isSubmitting}
              />
              <button
                className="password-toggle"
                type="button"
                onClick={onTogglePassword}
                aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                disabled={isSubmitting}
              >
                <span className="sr-only">{showPassword ? "Ocultar senha" : "Mostrar senha"}</span>
                {showPassword ? (
                  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M3.53 2.47a.75.75 0 0 0-1.06 1.06l2.33 2.33C2.96 7.39 1.66 9.64 1 12c1.85 6.22 7.84 9.75 11 9.75 1.66 0 3.6-.54 5.37-1.57l2.1 2.1a.75.75 0 1 0 1.06-1.06l-2.21-2.2a16.2 16.2 0 0 0 2.73-3.53C22.4 14.61 23.7 12.36 24 12c-1.93-6.34-7.86-9.75-11-9.75-1.74 0-3.72.58-5.54 1.69L3.53 2.47ZM12 7.5c.5 0 .98.08 1.43.24l-1.57 1.57a2.25 2.25 0 0 0-2.16 2.16l-1.57 1.57A4.5 4.5 0 0 1 12 7.5Zm0 9a4.5 4.5 0 0 1-4.5-4.5c0-.5.08-.98.24-1.43l1.57 1.57A2.25 2.25 0 0 0 12 14.86l1.57 1.57c-.45.16-.93.24-1.57.24Zm0-13.5c3.13 0 8.28 3.2 10.31 8.25-.53 1.32-1.54 3.24-3.14 4.98l-2.04-2.04a4.43 4.43 0 0 0 .62-2.24 4.5 4.5 0 0 0-4.5-4.5c-.85 0-1.66.23-2.35.63L8.46 6.82A9.5 9.5 0 0 1 12 3ZM4.43 6.1l2.08 2.08A14.5 14.5 0 0 0 2.63 12c1.98 4.9 6.89 8.25 9.37 8.25 1.47 0 3.07-.39 4.56-1.09l2.07 2.07C16.98 22.24 14.58 22.75 12 22.75c-3.88 0-10.69-4.3-12-10.75a16.3 16.3 0 0 1 4.43-5.9Z" />
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M12 5.25c3.13 0 8.28 3.2 10.31 8.25C20.28 18.8 15.13 22 12 22s-8.28-3.2-10.31-8.25C3.72 8.45 8.87 5.25 12 5.25Zm0 2.25A4.5 4.5 0 1 0 12 16.5 4.5 4.5 0 0 0 12 7.5Zm0 2.25A2.25 2.25 0 1 1 12 14.25 2.25 2.25 0 0 1 12 9.75Z" />
                  </svg>
                )}
              </button>
            </div>
          </label>

          {loginError ? <div className="feedback error">{loginError}</div> : null}

          <button className="primary-button" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Autenticando..." : "Entrar"}
          </button>
        </form>
      </section>
    </div>
  );
}

function TermsModal({ authUser, termsHtml, isLoading, isSubmitting, termsError, hasAccepted, onAcceptanceChange, onAccept, onLogout }) {
  return (
    <div className="terms-backdrop">
      <section className="terms-modal" role="dialog" aria-modal="true" aria-labelledby="terms-title">
        <span className="brand-kicker">Aceite de termo</span>
        <h2 id="terms-title">Termo de Uso e Condições Comerciais</h2>
        <p>
          Usuario: <strong>{authUser.Login}</strong>
        </p>

        <div className="terms-content" aria-live="polite">
          {isLoading ? <p>Carregando o Termo de Uso...</p> : null}
          {!isLoading && termsHtml ? (
            // O HTML vem exclusivamente do arquivo interno servido por /api/User/GetTerms.
            <div dangerouslySetInnerHTML={{ __html: termsHtml }} />
          ) : null}
        </div>

        {termsError ? <div className="feedback error">{termsError}</div> : null}

        <label className="terms-acceptance">
          <input
            type="checkbox"
            checked={hasAccepted}
            onChange={(event) => onAcceptanceChange(event.target.checked)}
            disabled={isLoading || isSubmitting || !termsHtml}
          />
          <span>Li e aceito os Termos de Uso</span>
        </label>

        <div className="terms-actions">
          <button className="secondary-button" type="button" onClick={onLogout} disabled={isSubmitting}>
            Recusar e sair
          </button>
          <button className="primary-button" type="button" onClick={onAccept} disabled={isLoading || isSubmitting || !termsHtml || !hasAccepted}>
            {isSubmitting ? "Registrando..." : "Aceitar e continuar"}
          </button>
        </div>
      </section>
    </div>
  );
}

function UsersScreen(props) {
  const {
    authUser,
    users,
    userForm,
    isLoading,
    isSaving,
    listError,
    saveError,
    saveMessage,
    isEditing,
    onSearch,
    onEdit,
    onFormChange,
    onSubmit,
    onCancel,
  } = props;

  const isAdminUser = authUser?.IsAdmin === 1;

  return (
    <section className="page-shell">
      <article className="content-card form-panel compact-crud-card">
        <CardHeader
          title="Dados do usuario"
          description={isEditing ? "Edite os dados do usuario selecionado." : "Cadastre e consulte usuarios."}
        />

        <form className="crud-form-grid" onSubmit={onSubmit}>
          <label className="field-block">
            <span>Login</span>
            <input name="Login" type="text" value={userForm.Login} onChange={onFormChange} placeholder="Login" disabled={isSaving} />
          </label>

          {!isEditing ? (
            <label className="field-block">
              <span>Senha</span>
              <input name="Senha" type="password" value={userForm.Senha} onChange={onFormChange} placeholder="Senha inicial" disabled={isSaving} />
            </label>
          ) : null}

          {isAdminUser ? (
            <label className="field-block">
              <span>Administrador</span>
              <select name="IsAdmin" value={userForm.IsAdmin} onChange={onFormChange} disabled={isSaving}>
                <option value="">Todos</option>
                <option value="1">{formatYesNo(1)}</option>
                <option value="0">{formatYesNo(0)}</option>
              </select>
            </label>
          ) : null}

          <label className="field-block">
            <span>Bloqueado</span>
            <select name="IsBlocked" value={userForm.IsBlocked} onChange={onFormChange} disabled={isSaving}>
              <option value="">Todos</option>
              <option value="0">{formatYesNo(0)}</option>
              <option value="1">{formatYesNo(1)}</option>
            </select>
          </label>

          <label className="field-block">
            <span>Status</span>
            <select name="CdStatus" value={userForm.CdStatus} onChange={onFormChange} disabled={isSaving}>
              <option value="">Todos</option>
              <option value="1">{formatStatusLabel(1)}</option>
              <option value="0">{formatStatusLabel(0)}</option>
            </select>
          </label>

          <label className="field-block">
            <span>Termos de Uso</span>
            <select name="TermsUse" value={userForm.TermsUse} onChange={onFormChange} disabled={isSaving}>
              <option value="">Todos</option>
              <option value="0">{formatYesNo(0)}</option>
              <option value="1">{formatYesNo(1)}</option>
            </select>
          </label>

          {saveError ? <div className="feedback error full-width">{saveError}</div> : null}
          {saveMessage ? <div className="feedback success full-width">{saveMessage}</div> : null}

          <div className="crud-actions full-width">
            <button className="primary-button compact-button" type="submit" disabled={isSaving}>
              {isSaving ? "Salvando..." : "Salvar usuario"}
            </button>
            <button className="secondary-button compact-button" type="button" onClick={onCancel} disabled={isSaving}>
              Limpar
            </button>
            <button className="secondary-button compact-button" type="button" onClick={onSearch} disabled={isLoading || isSaving}>
              {isLoading ? "Pesquisando..." : "Pesquisar"}
            </button>
          </div>
        </form>
      </article>

      <article className="content-card table-panel crud-table-panel">
        <CardHeader title="Usuarios cadastrados" />

        {listError ? <div className="feedback error">{listError}</div> : null}

        <div className="table-card">
          <table className="data-table">
            <thead>
              <tr>
                <th>Login</th>
                {isAdminUser ? <th>Administrador</th> : null}
                <th>Bloqueado</th>
                <th>Status</th>
                <th>Termos de Uso</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {users.length === 0 ? (
                <tr>
                  <td colSpan={isAdminUser ? "6" : "5"} className="empty-state-cell">Nenhum usuario encontrado.</td>
                </tr>
              ) : (
                users.map((user) => (
                  <tr key={user.IdUsuario}>
                    <td>{user.Login}</td>
                    {isAdminUser ? <td><FlagValue value={user.IsAdmin} /></td> : null}
                    <td><FlagValue value={user.IsBlocked} /></td>
                    <td><StatusValue value={user.CdStatus} /></td>
                    <td><FlagValue value={user.TermsUse} /></td>
                    <td>
                      <button className="secondary-button compact-button" type="button" onClick={() => onEdit(user)}>
                        Editar
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </article>
    </section>
  );
}

function ProductNutritionModal({
  isOpen,
  productName,
  items,
  isLoading,
  isSaving,
  error,
  message,
  onAdd,
  onChange,
  onRemove,
  onCancel,
  onSave,
}) {
  if (!isOpen) {
    return null;
  }

  const canEdit = !isLoading && !error && !isSaving;

  return (
    <div className="nutrition-backdrop" role="presentation">
      <section className="nutrition-modal" role="dialog" aria-modal="true" aria-labelledby="product-nutrition-title">
        <div className="nutrition-modal-header">
          <div>
            <span className="brand-kicker">Cadastro do produto</span>
            <h2 id="product-nutrition-title">Valores Nutricionais</h2>
            <p>{productName || "Produto"}</p>
          </div>
          <button
            className="nutrition-modal-close-button"
            type="button"
            onClick={onCancel}
            disabled={isSaving}
            aria-label="Fechar valores nutricionais"
          >
            ×
          </button>
        </div>

        {isLoading ? <div className="nutrition-status">Carregando valores nutricionais...</div> : null}
        {error ? <div className="feedback error">{error}</div> : null}
        {message ? <div className="feedback success">{message}</div> : null}

        {!isLoading && !error ? (
          <>
            {items.length === 0 ? (
              <div className="nutrition-empty-state">
                <p>Nenhum valor nutricional cadastrado para este produto.</p>
                <button className="secondary-button compact-button" type="button" onClick={onAdd} disabled={isSaving}>
                  + Adicionar valor nutricional
                </button>
              </div>
            ) : (
              <>
                <div className="nutrition-table-card">
                  <table className="nutrition-table">
                    <thead>
                      <tr>
                        <th>Nutriente</th>
                        <th>Quantidade por porção</th>
                        <th>%VD</th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, index) => (
                        <tr key={`${index}-${item.Ordem || "novo"}`}>
                          <td>
                            <input
                              className="table-input"
                              type="text"
                              value={item.Descricao}
                              onChange={(event) => onChange(index, "Descricao", event.target.value)}
                              aria-label={`Descrição nutricional da linha ${index + 1}`}
                              disabled={isSaving}
                            />
                          </td>
                          <td>
                            <input
                              className="table-input"
                              type="text"
                              value={item.QuantidadePorPorcao}
                              onChange={(event) => onChange(index, "QuantidadePorPorcao", event.target.value)}
                              aria-label={`Quantidade por porção da linha ${index + 1}`}
                              disabled={isSaving}
                            />
                          </td>
                          <td>
                            <input
                              className="table-input"
                              type="text"
                              value={item.PercentualVD}
                              onChange={(event) => onChange(index, "PercentualVD", event.target.value)}
                              aria-label={`Percentual VD da linha ${index + 1}`}
                              disabled={isSaving}
                            />
                          </td>
                          <td>
                            <button
                              className="nutrition-delete-button"
                              type="button"
                              onClick={() => onRemove(index)}
                              disabled={isSaving}
                              aria-label={`Excluir valor nutricional da linha ${index + 1}`}
                            >
                              Excluir
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <button className="secondary-button compact-button nutrition-add-button" type="button" onClick={onAdd} disabled={isSaving}>
                  + Adicionar valor nutricional
                </button>
              </>
            )}
          </>
        ) : null}

        <div className="nutrition-modal-actions">
          <button className="secondary-button compact-button" type="button" onClick={onCancel} disabled={isSaving}>
            Fechar
          </button>
          <button className="primary-button compact-button" type="button" onClick={onSave} disabled={!canEdit}>
            {isSaving ? "Salvando..." : "Salvar valores nutricionais"}
          </button>
        </div>
      </section>
    </div>
  );
}

function ProductsScreen(props) {
  const {
    products,
    productTypes,
    productForm,
    isLoading,
    isSaving,
    listError,
    saveError,
    saveMessage,
    isEditing,
    onSearch,
    onEdit,
    onCopy,
    onFormChange,
    onSubmit,
    onCancel,
    onOpenNutrition,
  } = props;

  const hasSavedProduct = Number(productForm.IdProduto || 0) > 0;

  return (
    <section className="page-shell">
      <article className="content-card form-panel compact-crud-card">
        <CardHeader
          title="Dados do produto"
          description={isEditing ? "Edite os dados do produto selecionado." : "Cadastre e consulte produtos."}
        />

        <form className="crud-form-grid" onSubmit={onSubmit}>
          <label className="field-block">
            <span>Código do Produto no ERP</span>
            <input name="CodigoExterno" type="text" value={productForm.CodigoExterno} onChange={onFormChange} placeholder="Código do produto no ERP" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>SKU do Produto</span>
            <input name="CodigoBaseProduto" type="text" value={productForm.CodigoBaseProduto} onChange={onFormChange} placeholder="SKU do produto" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>EAN do Produto</span>
            <input name="CodBarras" type="text" value={productForm.CodBarras} onChange={onFormChange} placeholder="EAN do produto" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Descrição</span>
            <input name="Descricao" type="text" value={productForm.Descricao} onChange={onFormChange} placeholder="Descrição do produto" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Tempo para Vencimento (em dias)</span>
            <input name="ShelfLife" type="number" min="0" step="1" value={productForm.ShelfLife} onChange={onFormChange} placeholder="Tempo para vencimento em dias" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Classificação</span>
            <select name="IdTipoProduto" value={productForm.IdTipoProduto} onChange={onFormChange} disabled={isSaving}>
              <option value="">Todos</option>
              {productTypes.map((productType) => (
                <option key={productType.IdTipoProduto} value={productType.IdTipoProduto}>
                  {productType.Descricao}
                </option>
              ))}
            </select>
          </label>

          <label className="field-block">
            <span>Peso</span>
            <input name="Peso" type="number" min="0" step="0.001" value={productForm.Peso} onChange={onFormChange} placeholder="Peso com 3 casas" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Unidade de Medida</span>
            <input name="UnidadeMedida" type="text" maxLength="20" value={productForm.UnidadeMedida} onChange={onFormChange} placeholder="kg, g, ml, L" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Preço Venda</span>
            <input name="PrecoVenda" type="number" min="0" step="0.01" value={productForm.PrecoVenda} onChange={onFormChange} placeholder="Preço com 2 casas" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Marca Produto</span>
            <input name="MarcaProduto" type="text" value={productForm.MarcaProduto} onChange={onFormChange} placeholder="Marca do produto" disabled={isSaving} />
          </label>

          <label className="field-block full-width">
            <span>Porção Nutricional</span>
            <input name="PorcaoNutricional" type="text" maxLength="200" value={productForm.PorcaoNutricional} onChange={onFormChange} placeholder="Porção de 15 g (1 colher de sopa)" disabled={isSaving} />
          </label>

          <div className="field-block gluten-options">
            <span>Glúten</span>
            <label>
              <input name="ContemGluten" type="radio" value="1" checked={String(productForm.ContemGluten) === "1"} onChange={onFormChange} disabled={isSaving} /> CONTÉM GLÚTEN
            </label>
            <label>
              <input name="ContemGluten" type="radio" value="0" checked={String(productForm.ContemGluten) === "0"} onChange={onFormChange} disabled={isSaving} /> NÃO CONTÉM GLÚTEN
            </label>
          </div>

          <label className="field-block full-width">
            <span>Ingredientes</span>
            <textarea name="Ingredientes" maxLength="1000" value={productForm.Ingredientes} onChange={onFormChange} placeholder="Informe os ingredientes do produto" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Status</span>
            <select name="CdStatus" value={productForm.CdStatus} onChange={onFormChange} disabled={isSaving}>
              <option value="">Todos</option>
              <option value="1">{formatStatusLabel(1)}</option>
              <option value="0">{formatStatusLabel(0)}</option>
            </select>
          </label>

          {saveError ? <div className="feedback error full-width">{saveError}</div> : null}
          {saveMessage ? <div className="feedback success full-width">{saveMessage}</div> : null}

          <div className="crud-actions full-width">
            <button className="primary-button compact-button" type="submit" disabled={isSaving}>
              {isSaving ? "Salvando..." : "Salvar produto"}
            </button>
            <button className="secondary-button compact-button" type="button" onClick={onCancel} disabled={isSaving}>
              Limpar
            </button>
            <button className="secondary-button compact-button" type="button" onClick={onSearch} disabled={isLoading || isSaving}>
              {isLoading ? "Pesquisando..." : "Pesquisar"}
            </button>
            <button
              className="secondary-button compact-button"
              type="button"
              onClick={onCopy}
              disabled={!hasSavedProduct || isLoading || isSaving}
              title={
                hasSavedProduct
                  ? "Usar os dados do formulário em um novo cadastro"
                  : "Selecione um produto pelo botão Editar para copiar seus dados"
              }
            >
              Copiar produto
            </button>
            <button className="secondary-button compact-button" type="button" onClick={onOpenNutrition} disabled={!hasSavedProduct || isSaving}>
              Valores Nutricionais
            </button>
            {!hasSavedProduct ? <span className="product-nutrition-note">Salve o produto antes de cadastrar os valores nutricionais.</span> : null}
          </div>
        </form>
      </article>

      <article className="content-card table-panel crud-table-panel">
        <CardHeader title="Produtos cadastrados" />

        {listError ? <div className="feedback error">{listError}</div> : null}

        <div className="table-card">
          <table className="data-table">
            <thead>
              <tr>
                <th>Ações</th>
                <th>SKU do Produto</th>
                <th>EAN do Produto</th>
                <th>Descrição</th>
                <th>Tempo para Vencimento</th>
                <th>Classificação</th>
                <th>Peso</th>
                <th>Preço Venda</th>
                <th>Marca Produto</th>
                <th>Unidade</th>
                <th>Porção Nutricional</th>
                <th>Glúten</th>
                <th>Ingredientes</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {products.length === 0 ? (
                <tr>
                  <td colSpan="14" className="empty-state-cell">Nenhum produto encontrado.</td>
                </tr>
              ) : (
                products.map((product) => (
                  <tr key={product.IdProduto}>
                    <td>
                      <button className="secondary-button compact-button" type="button" onClick={() => onEdit(product)}>
                        Editar
                      </button>
                    </td>
                    <td>{product.CodigoBaseProduto}</td>
                    <td>{product.CodBarras}</td>
                    <td>{product.Descricao}</td>
                    <td>{product.ShelfLife || 0}</td>
                    <td>{product.IdTipoProduto > 0 ? getProductTypeLabel(product.IdTipoProduto) : "-"}</td>
                    <td>{product.Peso ?? "-"}</td>
                    <td>{product.PrecoVenda ?? "-"}</td>
                    <td>{product.MarcaProduto || "-"}</td>
                    <td>{product.UnidadeMedida || "-"}</td>
                    <td>{product.PorcaoNutricional || "-"}</td>
                    <td>{product.ContemGluten === 1 ? "CONTÉM GLÚTEN" : product.ContemGluten === 0 ? "NÃO CONTÉM GLÚTEN" : "-"}</td>
                    <td>{product.Ingredientes || "-"}</td>
                    <td><StatusValue value={product.CdStatus} /></td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </article>
    </section>
  );
}

function ClientsScreen(props) {
  const {
    clients,
    clientForm,
    isLoading,
    isSaving,
    listError,
    saveError,
    saveMessage,
    isEditing,
    onSearch,
    onEdit,
    onFormChange,
    onSubmit,
    onCancel,
  } = props;

  return (
    <section className="page-shell">
      <article className="content-card form-panel compact-crud-card">
        <CardHeader
          title="Dados do cliente"
          description={isEditing ? "Edite os dados do cliente selecionado." : "Cadastre e consulte clientes."}
        />

        <form className="crud-form-grid" onSubmit={onSubmit}>
          <label className="field-block">
            <span>CNPJ</span>
            <input name="CNPJ" type="text" value={clientForm.CNPJ} onChange={onFormChange} placeholder="CNPJ do cliente" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Razão Social</span>
            <input name="RazaoSocial" type="text" value={clientForm.RazaoSocial} onChange={onFormChange} placeholder="Razão social" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Nome Fantasia</span>
            <input name="NomeFantasia" type="text" value={clientForm.NomeFantasia} onChange={onFormChange} placeholder="Nome fantasia" disabled={isSaving} />
          </label>

          <label className="field-block full-width">
            <span>Endereço Completo</span>
            <input name="EnderecoCompleto" type="text" value={clientForm.EnderecoCompleto} onChange={onFormChange} placeholder="Endereço completo do cliente" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Status</span>
            <select name="CdStatus" value={clientForm.CdStatus} onChange={onFormChange} disabled={isSaving}>
              <option value="">Todos</option>
              <option value="1">{formatStatusLabel(1)}</option>
              <option value="0">{formatStatusLabel(0)}</option>
            </select>
          </label>

          {saveError ? <div className="feedback error full-width">{saveError}</div> : null}
          {saveMessage ? <div className="feedback success full-width">{saveMessage}</div> : null}

          <div className="crud-actions full-width">
            <button className="primary-button compact-button" type="submit" disabled={isSaving}>
              {isSaving ? "Salvando..." : "Salvar cliente"}
            </button>
            <button className="secondary-button compact-button" type="button" onClick={onCancel} disabled={isSaving}>
              Limpar
            </button>
            <button className="secondary-button compact-button" type="button" onClick={onSearch} disabled={isLoading || isSaving}>
              {isLoading ? "Pesquisando..." : "Pesquisar"}
            </button>
          </div>
        </form>
      </article>

      <article className="content-card table-panel crud-table-panel">
        <CardHeader title="Clientes cadastrados" />

        {listError ? <div className="feedback error">{listError}</div> : null}

        <div className="table-card">
          <table className="data-table">
            <thead>
              <tr>
                <th>CNPJ</th>
                <th>Razão Social</th>
                <th>Nome Fantasia</th>
                <th>Endereço Completo</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {clients.length === 0 ? (
                <tr>
                  <td colSpan="6" className="empty-state-cell">Nenhum cliente encontrado.</td>
                </tr>
              ) : (
                clients.map((client) => (
                  <tr key={client.IdCliente}>
                    <td>{client.CNPJ || "-"}</td>
                    <td>{client.RazaoSocial || "-"}</td>
                    <td>{client.NomeFantasia || "-"}</td>
                    <td>{client.EnderecoCompleto || "-"}</td>
                    <td><StatusValue value={client.CdStatus} /></td>
                    <td>
                      <button className="secondary-button compact-button" type="button" onClick={() => onEdit(client)}>
                        Editar
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </article>
    </section>
  );
}

function PrintersScreen(props) {
  const {
    printers,
    printerForm,
    isLoading,
    isSaving,
    listError,
    saveError,
    saveMessage,
    isEditing,
    onSearch,
    onEdit,
    onFormChange,
    onSubmit,
    onCancel,
  } = props;

  return (
    <section className="page-shell">
      <article className="content-card form-panel compact-crud-card">
        <CardHeader
          title="Dados da impressora"
          description={isEditing ? "Edite os dados da impressora selecionada." : "Cadastre e consulte impressoras."}
        />

        <form className="crud-form-grid" onSubmit={onSubmit}>
          <label className="field-block">
            <span>Código Impressora</span>
            <input name="CodigoImpressora" type="text" value={printerForm.CodigoImpressora} onChange={onFormChange} placeholder="Código da impressora" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Nome da Rede</span>
            <input name="NomeRede" type="text" value={printerForm.NomeRede} onChange={onFormChange} placeholder="Nome exato instalado no Windows" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Nome do Computador na Rede</span>
            <input name="NomeComputadorRede" type="text" value={printerForm.NomeComputadorRede} onChange={onFormChange} placeholder="Computador da impressora" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Marca</span>
            <input name="Marca" type="text" value={printerForm.Marca} onChange={onFormChange} placeholder="Marca da impressora" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Modelo</span>
            <input name="Modelo" type="text" value={printerForm.Modelo} onChange={onFormChange} placeholder="Modelo da impressora" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Apelido do Computador</span>
            <input name="Apelido" type="text" value={printerForm.Apelido} onChange={onFormChange} placeholder="Apelido para operacao" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Status</span>
            <select name="CdStatus" value={printerForm.CdStatus} onChange={onFormChange} disabled={isSaving}>
              <option value="">Todos</option>
              <option value="1">{formatStatusLabel(1)}</option>
              <option value="0">{formatStatusLabel(0)}</option>
            </select>
          </label>

          {saveError ? <div className="feedback error full-width">{saveError}</div> : null}
          {saveMessage ? <div className="feedback success full-width">{saveMessage}</div> : null}

          <div className="crud-actions full-width">
            <button className="primary-button compact-button" type="submit" disabled={isSaving}>
              {isSaving ? "Salvando..." : "Salvar impressora"}
            </button>
            <button className="secondary-button compact-button" type="button" onClick={onCancel} disabled={isSaving}>
              Limpar
            </button>
            <button className="secondary-button compact-button" type="button" onClick={onSearch} disabled={isLoading || isSaving}>
              {isLoading ? "Pesquisando..." : "Pesquisar"}
            </button>
          </div>
        </form>
      </article>

      <article className="content-card table-panel crud-table-panel">
        <CardHeader title="Impressoras cadastradas" />

        {listError ? <div className="feedback error">{listError}</div> : null}

        <div className="table-card">
          <table className="data-table">
            <thead>
              <tr>
                <th>Código Impressora</th>
                <th>Nome da Rede</th>
                <th>Nome do Computador na Rede</th>
                <th>Marca</th>
                <th>Modelo</th>
                <th>Apelido do Computador</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {printers.length === 0 ? (
                <tr>
                  <td colSpan="8" className="empty-state-cell">Nenhuma impressora encontrada.</td>
                </tr>
              ) : (
                printers.map((printer) => (
                  <tr key={printer.IdImpressora}>
                    <td>{printer.CodigoImpressora}</td>
                    <td>{printer.NomeRede}</td>
                    <td>{printer.NomeComputadorRede}</td>
                    <td>{printer.Marca}</td>
                    <td>{printer.Modelo}</td>
                    <td>{printer.Apelido}</td>
                    <td><StatusValue value={printer.CdStatus} /></td>
                    <td>
                      <button className="secondary-button compact-button" type="button" onClick={() => onEdit(printer)}>
                        Editar
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </article>
    </section>
  );
}

function LayoutZplPreview({ zpl }) {
  const [rotation, setRotation] = useState(180);
  const [preview, setPreview] = useState({ zpl: "", imageUrl: "", error: "" });

  // Nunca mostra a imagem de um ZPL anterior como se fosse a atual.
  const imageUrl = preview.zpl === zpl ? preview.imageUrl : "";
  const previewError = preview.zpl === zpl ? preview.error : "";

  useEffect(() => {
    if (!zpl.trim()) {
      setPreview({ zpl, imageUrl: "", error: "Informe um código ZPL para visualizar." });
      return;
    }

    const controller = new AbortController();
    let disposed = false;
    let objectUrl = "";
    let timeoutId;

    setPreview({ zpl, imageUrl: "", error: "" });

    // Aguarda uma pausa na digitação antes de atualizar a imagem.
    const debounceId = window.setTimeout(async () => {
      let timedOut = false;
      timeoutId = window.setTimeout(() => {
        timedOut = true;
        controller.abort();
      }, 15000);

      try {
        const response = await fetch(
          "https://api.labelary.com/v1/printers/8dpmm/labels/6x6/0/",
          {
            method: "POST",
            headers: {
              Accept: "image/png",
              "Content-Type": "application/x-www-form-urlencoded",
            },
            // O Labelary espera o ZPL bruto no corpo: não usar JSON.stringify.
            body: zpl,
            signal: controller.signal,
            credentials: "omit",
            referrerPolicy: "no-referrer",
          }
        );

        if (!response.ok) {
          throw new Error(
            response.status === 429
              ? "Limite de consultas do Labelary atingido. Aguarde e tente novamente."
              : `Não foi possível gerar a imagem (HTTP ${response.status}). Verifique o ZPL.`
          );
        }

        const imageBlob = await response.blob();
        if (!imageBlob.type.startsWith("image/") || imageBlob.size === 0) {
          throw new Error("O serviço não retornou uma imagem válida.");
        }

        if (disposed) return;

        objectUrl = URL.createObjectURL(imageBlob);
        setPreview({ zpl, imageUrl: objectUrl, error: "" });
      } catch (error) {
        if (disposed) return;

        setPreview({
          zpl,
          imageUrl: "",
          error: timedOut
            ? "A pré-visualização demorou demais. Feche o painel e tente novamente."
            : error instanceof TypeError
              ? "Não foi possível acessar o Labelary. Verifique a conexão e as permissões de rede."
              : error.message || "Falha ao gerar a pré-visualização.",
        });
      } finally {
        window.clearTimeout(timeoutId);
      }
    }, 600);

    return () => {
      disposed = true;
      window.clearTimeout(debounceId);
      window.clearTimeout(timeoutId);
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [zpl]);

  return (
    <section
      id="layout-zpl-preview"
      className="content-card full-width"
      aria-label="Pré-visualização da etiqueta"
      aria-busy={!imageUrl && !previewError}
      style={{ gridColumn: "1 / -1", minWidth: 0, marginTop: "16px", padding: "16px" }}
    >
      <CardHeader
        title="Pré-visualização da etiqueta"
        description="Modelo ZPL"
      />

      {!imageUrl && !previewError ? <p role="status">Gerando pré-visualização...</p> : null}
      {previewError ? <div className="feedback error" role="alert">{previewError}</div> : null}

      {imageUrl ? (
        <>
          <div
            style={{
              width: "100%",
              maxWidth: "900px",
              aspectRatio: "1 / 1",
              margin: "16px auto",
              overflow: "hidden",
              backgroundColor: "#fff",
              border: "1px solid #ddd",
            }}
          >
            <img
              src={imageUrl}
              alt="Pré-visualização do ZPL informado"
              style={{ display: "block", width: "100%", height: "100%", objectFit: "contain", transform: `rotate(${rotation}deg)` }}
              onError={() => setPreview((current) => (
                current.imageUrl === imageUrl
                  ? { ...current, imageUrl: "", error: "Não foi possível exibir a imagem retornada." }
                  : current
              ))}
            />
          </div>
          <div className="crud-actions" style={{ justifyContent: "center" }}>
            <button className="secondary-button compact-button" type="button" onClick={() => setRotation((current) => (current + 270) % 360)}>
              Girar 90° à esquerda
            </button>
            <button className="secondary-button compact-button" type="button" onClick={() => setRotation((current) => (current + 90) % 360)}>
              Girar 90° à direita
            </button>
          </div>
        </>
      ) : null}
    </section>
  );
}

function LayoutsScreen(props) {
  const {
    layouts,
    activePrintFields,
    layoutForm,
    layoutFields,
    isLoading,
    isSaving,
    listError,
    saveError,
    saveMessage,
    isEditing,
    onSearch,
    onEdit,
    onCopy,
    onFormChange,
    onFieldChange,
    onSubmit,
    onCancel,
  } = props;
  // const visibleLayoutFields = layoutFields
  //   .map((field, index) => ({ field, index }))
  //   .filter(({ field }) => {
  //     const description = normalizeLayoutFieldText(field.DescricaoCampo);
  //     const replaceTag = normalizeLayoutFieldText(field.ReplaceTag);
  //     return description && replaceTag;
  //   });
  const [isZplPreviewOpen, setIsZplPreviewOpen] = useState(false);
  const canPreviewZpl = layoutForm.ZPL !== "";

  // Fecha ao trocar de registro, limpar o ZPL ou resetar o formulário.
  useEffect(() => {
    setIsZplPreviewOpen(false);
  }, [layoutForm.IdLayoutImpressao, canPreviewZpl]);

  const visibleLayoutFields = layoutFields
    .map((field, index) => ({ field, index }))
    .filter(({ field }) => {
      const description = normalizeLayoutFieldText(field.DescricaoCampo);
      const replaceTag = normalizeLayoutFieldText(field.ReplaceTag);
      return description && replaceTag;
    });

  return (
    <section className="page-shell">
      <article className="content-card form-panel compact-crud-card">
        <CardHeader
          title="Dados do layout"
          description={isEditing ? "Edite os dados do layout selecionado." : "Cadastre e consulte layouts de etiqueta."}
        />

        <form className="crud-form-grid" onSubmit={onSubmit}>
          <label className="field-block">
            <span>Código do Layout</span>
            <input name="CodigoLayout" type="text" value={layoutForm.CodigoLayout} onChange={onFormChange} placeholder="Código do layout" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Descrição do Layout</span>
            <input name="Descricao" type="text" value={layoutForm.Descricao} onChange={onFormChange} placeholder="Descrição do layout" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Quantidade de Colunas para Impressão</span>
            <input name="QtdeColunasImpressao" type="number" min="1" value={layoutForm.QtdeColunasImpressao} onChange={onFormChange} placeholder="Quantidade de colunas" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Altura</span>
            <input name="Altura" type="number" step="0.001" value={layoutForm.Altura} onChange={onFormChange} placeholder="Altura do layout" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Largura</span>
            <input name="Largura" type="number" step="0.001" value={layoutForm.Largura} onChange={onFormChange} placeholder="Largura do layout" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Status</span>
            <select name="CdStatus" value={layoutForm.CdStatus} onChange={onFormChange} disabled={isSaving}>
              <option value="">Todos</option>
              <option value="1">{formatStatusLabel(1)}</option>
              <option value="0">{formatStatusLabel(0)}</option>
            </select>
          </label>

          <label className="field-block full-width">
            <span>ZPL</span>
            <textarea
              className="code-editor"
              name="ZPL"
              value={layoutForm.ZPL}
              onChange={onFormChange}
              placeholder="Cole ou edite o ZPL com as tags oficiais do layout"
              rows="12"
              disabled={isSaving}
            />
          </label>

          <details className="nutrition-zpl-help full-width">
            <summary>Como criar linhas variáveis de informação nutricional</summary>
            <p>
              Delimite a linha ZPL com <code>{"{{#INFORMACAONUTRICIONAL Y=118 PASSO=28 MAX=8}}"}</code> e <code>{"{{/INFORMACAONUTRICIONAL}}"}</code>.
            </p>
            <p>
              Marcadores disponíveis: <code>{"{{Y}}"}</code>, <code>{"{{Y+N}}"}</code>, <code>{"{{Y-N}}"}</code>, <code>{"{{DESCRICAO}}"}</code>, <code>{"{{QUANTIDADEPORPORCAO}}"}</code>, <code>{"{{PERCENTUALVD}}"}</code> e <code>{"{{ORDEM}}"}</code>.
            </p>
          </details>

          <div className="content-card field-reference-card full-width">
            <div className="section-heading">
              <span>Campos do layout</span>
              <h2>Campos do layout</h2>
            </div>

            <div className="hero-badges layout-tag-list">
              {visibleLayoutFields.map(({ field }) => (
                <span key={field.IdCampoImpressao} className="hero-badge">
                  {field.ReplaceTag}
                </span>
              ))}
            </div>

            <div className="table-card layout-fields-table">
              <table className="data-table">
                <thead>
                  <tr>
                    <th>Descrição do Campo</th>
                    <th>Replace Tag</th>
                    <th>Selecionado</th>
                    <th>Obrigatório</th>
                  </tr>
                </thead>
                <tbody>
                  {visibleLayoutFields.map(({ field, index }) => (
                    <tr key={field.IdCampoImpressao}>
                      <td>{field.DescricaoCampo}</td>
                      <td><code>{field.ReplaceTag}</code></td>
                      <td>
                        <label className="toggle-cell">
                          <input
                            type="checkbox"
                            checked={resolveFlag(field.Selecionado) === 1}
                            onChange={(event) => onFieldChange(index, "Selecionado", event.target.checked ? 1 : 0)}
                            disabled={isSaving}
                          />
                          <span>{formatYesNoStatus(field.Selecionado)}</span>
                        </label>
                      </td>
                      <td>
                        <label className="toggle-cell">
                          <input
                            type="checkbox"
                            checked={resolveFlag(field.Obrigatorio) === 1}
                            onChange={(event) => onFieldChange(index, "Obrigatorio", event.target.checked ? 1 : 0)}
                            disabled={isSaving}
                          />
                          <span>{formatYesNoStatus(field.Obrigatorio)}</span>
                        </label>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {saveError ? <div className="feedback error full-width">{saveError}</div> : null}
          {saveMessage ? <div className="feedback success full-width">{saveMessage}</div> : null}

          <div className="crud-actions full-width">
            <button className="primary-button compact-button" type="submit" disabled={isSaving}>
              {isSaving ? "Salvando..." : "Salvar layout"}
            </button>
            <button
              className="secondary-button compact-button"
              type="button"
              onClick={() => {
                setIsZplPreviewOpen(false);
                onCancel();
              }}
              disabled={isSaving}
            >
              Limpar
            </button>
            <button className="secondary-button compact-button" type="button" onClick={onSearch} disabled={isLoading || isSaving}>
              {isLoading ? "Pesquisando..." : "Pesquisar"}
            </button>
            <button
              className="secondary-button compact-button"
              type="button"
              onClick={() => {
                setIsZplPreviewOpen(false);
                onCopy();
              }}
              disabled={!isEditing || isLoading || isSaving}
              title={
                isEditing
                  ? "Usar os dados e os campos deste layout em uma nova etiqueta"
                  : "Selecione um layout pelo botão Editar para copiar seus dados"
              }
            >
              Copiar etiqueta
            </button>
            {canPreviewZpl ? (
              <button
                className="secondary-button compact-button"
                type="button"
                onClick={() => setIsZplPreviewOpen((current) => !current)}
                disabled={isLoading || isSaving}
                aria-expanded={isZplPreviewOpen}
                aria-controls="layout-zpl-preview"
              >
                PRÉ-VISUALIZAÇÃO
              </button>
            ) : null}
          </div>

          {isZplPreviewOpen && canPreviewZpl ? (
            <LayoutZplPreview zpl={layoutForm.ZPL} />
          ) : null}
        </form>
      </article>

      <article className="content-card table-panel crud-table-panel">
        <CardHeader title="Layouts cadastrados" />

        {listError ? <div className="feedback error">{listError}</div> : null}

        <div className="table-card">
          <table className="data-table">
            <thead>
              <tr>
                <th>Código do Layout</th>
                <th>Descrição do Layout</th>
                <th>Quantidade de Colunas para Impressão</th>
                <th>Altura</th>
                <th>Largura</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {layouts.length === 0 ? (
                <tr>
                  <td colSpan="7" className="empty-state-cell">Nenhum layout encontrado.</td>
                </tr>
              ) : (
                layouts.map((layout) => (
                  <tr key={layout.IdLayoutImpressao}>
                    <td>{layout.CodigoLayout}</td>
                    <td>{layout.Descricao}</td>
                    <td>{layout.QtdeColunasImpressao}</td>
                    <td>{layout.Altura ?? "-"}</td>
                    <td>{layout.Largura ?? "-"}</td>
                    <td><StatusValue value={layout.CdStatus} /></td>
                    <td>
                      <button
                        className="secondary-button compact-button"
                        type="button"
                        onClick={() => {
                          setIsZplPreviewOpen(false);
                          onEdit(layout);
                        }}
                        disabled={isLoading || isSaving}
                      >
                        Editar
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </article>
    </section>
  );
}

function PrintManagementScreen(props) {
  const {
    authUser,
    printRequestForm,
    products,
    activeClients,
    layouts,
    printers,
    productTypes,
    activePrintFields,
    isOptionsLoading,
    isSubmitting,
    optionsError,
    submitError,
    submitMessage,
    lastResult,
    creditBalance,
    creditBalanceLoading,
    creditBalanceError,
    onFormChange,
    onRefreshOptions,
    onSubmit,
    onReset,
    onRecharge,
  } = props;

  const selectedProduct = products.find((item) => item.IdProduto === Number(printRequestForm.IdProduto));
  const selectedLayout = layouts.find((item) => item.IdLayoutImpressao === Number(printRequestForm.IdLayoutImpressao));
  const selectedPrinter = printers.find((item) => item.IdImpressora === Number(printRequestForm.IdImpressora));
  const selectedProductShelfLife = Number(selectedProduct?.ShelfLife || 0);
  const saldoCredito = Number(creditBalance?.SaldoCredito);
  const custoCreditoImpressao = Number(creditBalance?.CustoCreditoImpressao);
  const quantidadeRequerida = Number(printRequestForm.QtdeRequerida);
  const hasCreditBalance = creditBalance?.SaldoCredito !== null && creditBalance?.CustoCreditoImpressao !== null && Number.isInteger(saldoCredito) && Number.isInteger(custoCreditoImpressao) && custoCreditoImpressao > 0;
  const custoDestaImpressao = hasCreditBalance && Number.isInteger(quantidadeRequerida) && quantidadeRequerida > 0
    ? quantidadeRequerida * custoCreditoImpressao
    : null;
  const creditInsufficient = custoDestaImpressao !== null && saldoCredito < custoDestaImpressao;
  const canSubmitWithCredits = custoDestaImpressao !== null && !creditInsufficient;

  return (
    <section className="page-shell">
      <div className="screen-grid screen-grid-narrow">
        <article className="content-card form-panel">
          <CardHeader
            title="Geração de Etiquetas"
            description="Preencha os dados e envie a Solicitação."
            badge="Envio"
          />

          <div className="inline-actions">
            <span className="inline-note">
              Preencha os dados e envie a Solicitação.
            </span>
          </div>

          {optionsError ? <div className="feedback error">{optionsError}</div> : null}

          <div className="credit-print-summary">
            <div>
              <span>Créditos disponíveis</span>
              <strong>{creditBalanceLoading ? "Carregando..." : hasCreditBalance ? saldoCredito : "Indisponível"}</strong>
            </div>
            <div>
              <span>Custo por etiqueta</span>
              <strong>{hasCreditBalance ? custoCreditoImpressao : "Indisponível"}</strong>
            </div>
            <div>
              <span>Custo desta impressão</span>
              <strong>{custoDestaImpressao ?? "Informe uma quantidade válida"}</strong>
            </div>
          </div>

          {creditBalanceError ? <div className="feedback error">{creditBalanceError}</div> : null}
          {creditInsufficient ? (
            <div className="credit-insufficient">
              <span>Créditos insuficientes para realizar esta impressão.</span>
              <CreditRechargeActions compact onOpen={onRecharge} />
            </div>
          ) : null}

          <form className="users-form-grid" onSubmit={onSubmit}>
            <label className="field-block">
              <span>Produto</span>
              <select name="IdProduto" value={printRequestForm.IdProduto} onChange={onFormChange} disabled={isOptionsLoading || isSubmitting}>
                <option value="">Selecione um produto ativo</option>
                {products.map((product) => (
                  <option key={product.IdProduto} value={product.IdProduto}>
                    {getProductSelectLabel(product)}
                  </option>
                ))}
              </select>
            </label>

            <label className="field-block">
              <span>Layout</span>
              <select name="IdLayoutImpressao" value={printRequestForm.IdLayoutImpressao} onChange={onFormChange} disabled={isOptionsLoading || isSubmitting}>
                <option value="">Selecione um layout ativo</option>
                {layouts.map((layout) => (
                  <option key={layout.IdLayoutImpressao} value={layout.IdLayoutImpressao}>
                    {getLayoutSelectLabel(layout)}
                  </option>
                ))}
              </select>
            </label>

            <label className="field-block">
              <span>Impressora</span>
              <select name="IdImpressora" value={printRequestForm.IdImpressora} onChange={onFormChange} disabled={isOptionsLoading || isSubmitting}>
                <option value="">Selecione uma impressora ativa</option>
                {printers.map((printer) => (
                  <option key={printer.IdImpressora} value={printer.IdImpressora}>
                    {getPrinterSelectLabel(printer)}
                  </option>
                ))}
              </select>
            </label>

            <label className="field-block">
              <span>Informe o Lote do Produto</span>
              <input name="CodLote" type="text" value={printRequestForm.CodLote} onChange={onFormChange} placeholder="Informe o lote do produto" disabled={isSubmitting} />
            </label>

            <label className="field-block">
              <span>Informe a Data de Fabricação</span>
              <input name="DtFabricacao" type="date" value={formatDateOnlyValue(printRequestForm.DtFabricacao)} onChange={onFormChange} disabled={isSubmitting} />
            </label>

            <label className="field-block">
              <span>Informe a Data de Validade</span>
              <input name="DtValidade" type="date" value={formatDateOnlyValue(printRequestForm.DtValidade)} onChange={onFormChange} disabled={isSubmitting} />
            </label>

            <label className="field-block">
              <span>Informe a Quantidade requerida de Etiquetas</span>
              <input name="QtdeRequerida" type="number" min="1" value={printRequestForm.QtdeRequerida} onChange={onFormChange} placeholder="Quantidade requerida de etiquetas" disabled={isSubmitting} />
            </label>

            <div className="content-card field-reference-card full-width">
              <div className="section-heading">
                <span>Resumo do envio</span>
                <h2>Resumo da Solicitação</h2>
              </div>

              <div className="summary-grid">
                <div>
                  <span>Produto</span>
                  <strong>{selectedProduct ? getProductLabel(selectedProduct) : "Não selecionado"}</strong>
                </div>
                <div>
                  <span>Layout</span>
                  <strong>{selectedLayout ? getLayoutLabel(selectedLayout) : "Não selecionado"}</strong>
                </div>
                <div>
                  <span>Impressora</span>
                  <strong>{selectedPrinter ? getPrinterLabel(selectedPrinter) : "Não selecionada"}</strong>
                </div>
                <div>
                  <span>Quantidade requerida</span>
                  <strong>{printRequestForm.QtdeRequerida || "0"}</strong>
                </div>
                <div>
                  <span>Validade calculada</span>
                  <strong>{printRequestForm.DtValidade || (printRequestForm.DtFabricacao ? addDaysToDateValue(printRequestForm.DtFabricacao, selectedProductShelfLife) : "-")}</strong>
                </div>
              </div>
            </div>

            {submitError ? <div className="feedback error full-width">{submitError}</div> : null}
            {submitMessage ? <div className="feedback success full-width">{submitMessage}</div> : null}

            <div className="inline-actions full-width">
              <button className="primary-button compact-button" type="submit" disabled={isSubmitting || isOptionsLoading || !canSubmitWithCredits}>
                {isSubmitting ? "Enviando..." : "Enviar Solicitação"}
              </button>
              <button className="secondary-button compact-button" type="button" onClick={onReset} disabled={isSubmitting}>
                Limpar
              </button>
            </div>
          </form>
        </article>

        <article className="content-card table-panel">
          <CardHeader
            title="Resultado do envio"
            description="Acompanhe o resultado da última Solicitação."
            badge="Retorno"
          />

          <div className="summary-grid">
            <div>
              <span>Solicitação</span>
              <strong>{lastResult?.IdImpressao || 0}</strong>
            </div>
            <div>
              <span>Status</span>
              <strong>{lastResult?.CdStatus || 0}</strong>
            </div>
            <div>
              <span>Impressora</span>
              <strong>{lastResult?.NomeRede || selectedPrinter?.NomeRede || "-"}</strong>
            </div>
            <div>
              <span>Mensagem de erro</span>
              <strong>{lastResult?.MensagemErro || "Sem erro retornado"}</strong>
            </div>
          </div>

        </article>

        <article className="content-card table-panel">
          <CardHeader
            title="Opções disponíveis"
            description="Consulte os dados disponíveis para a Operação."
            badge="Auxiliar"
          />

          <div className="stack-list">
            <div className="stack-row action-row">
              <div>
                <strong>Classificação</strong>
                <small>Tipos disponíveis para seleção.</small>
              </div>
              <span className="status-chip neutral">{productTypes.length}</span>
            </div>

            <div className="stack-row action-row">
              <div>
                <strong>Produto ativo</strong>
                <small>Produtos disponíveis para Solicitação.</small>
              </div>
              <span className="status-chip success">{products.length}</span>
            </div>

            <div className="stack-row action-row">
              <div>
                <strong>Cliente ativo</strong>
                <small>Clientes disponíveis para consulta.</small>
              </div>
              <span className="status-chip success">{activeClients.length}</span>
            </div>

            <div className="stack-row action-row">
              <div>
                <strong>Impressora ativa</strong>
                <small>Impressoras disponíveis para Operação.</small>
              </div>
              <span className="status-chip success">{printers.length}</span>
            </div>

            <div className="stack-row action-row">
              <div>
                <strong>Layout ativo</strong>
                <small>Layouts disponíveis para Operação.</small>
              </div>
              <span className="status-chip success">{layouts.length}</span>
            </div>

            <div className="stack-row action-row">
              <div>
                <strong>Campos de Impressão</strong>
                <small>Campos disponíveis para configuração.</small>
              </div>
              <span className="status-chip neutral">{activePrintFields.length}</span>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}

function CreditScreen(props) {
  const {
    creditBalance,
    creditBalanceLoading,
    creditBalanceError,
    creditHistory,
    creditHistoryLoading,
    creditHistoryError,
    creditHistoryFilter,
    onFilterChange,
    onSearch,
    onClearFilters,
    onRecharge,
  } = props;

  const hasBalance = creditBalance?.SaldoCredito !== null && creditBalance?.CustoCreditoImpressao !== null && Number.isInteger(Number(creditBalance?.SaldoCredito)) && Number.isInteger(Number(creditBalance?.CustoCreditoImpressao));

  return (
    <section className="page-shell">
      <article className="content-card credit-balance-card">
        <div>
          <span className="page-eyebrow">Seu saldo atual</span>
          <h2>Créditos disponíveis</h2>
          <strong>{creditBalanceLoading ? "Carregando..." : hasBalance ? Number(creditBalance.SaldoCredito) : "Indisponível"}</strong>
          <p>Custo por etiqueta: <b>{hasBalance ? Number(creditBalance.CustoCreditoImpressao) : "Indisponível"}</b></p>
        </div>
        <CreditRechargeActions onOpen={onRecharge} />
      </article>

      {creditBalanceError ? <div className="feedback error">{creditBalanceError}</div> : null}
      <CreditLowBalanceWarning creditBalance={creditBalance} onRecharge={onRecharge} />

      <article className="content-card filter-card">
        <CardHeader title="Histórico de créditos" description="Consulte as movimentações registradas para seu usuário." badge="Extrato" />
        <div className="users-filter-grid">
          <label className="field-block">
            <span>Data inicial</span>
            <input name="DataInicial" type="date" value={creditHistoryFilter.DataInicial} onChange={onFilterChange} />
          </label>
          <label className="field-block">
            <span>Data final</span>
            <input name="DataFinal" type="date" value={creditHistoryFilter.DataFinal} onChange={onFilterChange} />
          </label>
          <label className="field-block">
            <span>Tipo</span>
            <select name="TipoMovimento" value={creditHistoryFilter.TipoMovimento} onChange={onFilterChange}>
              <option value="">Todos</option>
              <option value="Pagamento">Pagamento</option>
              <option value="Impressao">Impressão</option>
              <option value="Reimpressao">Reimpressão</option>
            </select>
          </label>
        </div>
        <div className="inline-actions">
          <button className="secondary-button compact-button" type="button" onClick={onSearch} disabled={creditHistoryLoading}>
            {creditHistoryLoading ? "Pesquisando..." : "Pesquisar"}
          </button>
          <button className="secondary-button compact-button" type="button" onClick={onClearFilters} disabled={creditHistoryLoading}>
            Limpar filtros
          </button>
        </div>
        {creditHistoryError ? <div className="feedback error">{creditHistoryError}</div> : null}
      </article>

      <article className="content-card table-panel">
        <CardHeader title="Movimentações" description="Histórico somente para consulta." badge="Somente leitura" />
        <div className="table-card">
          <table className="data-table credit-history-table">
            <thead>
              <tr><th>Data</th><th>Tipo</th><th>Créditos</th><th>Observações</th></tr>
            </thead>
            <tbody>
              {creditHistoryLoading ? <tr><td colSpan="4" className="empty-state-cell">Carregando movimentações...</td></tr> : null}
              {!creditHistoryLoading && creditHistory.length === 0 ? <tr><td colSpan="4" className="empty-state-cell">Nenhuma movimentação de créditos encontrada.</td></tr> : null}
              {!creditHistoryLoading ? creditHistory.map((item) => (
                <tr key={item.IdCreditoHistorico || `${item.DtMovimento}-${item.TipoMovimento}`}>
                  <td>{formatTimestampLabel(item.DtMovimento)}</td>
                  <td>{formatCreditMovementType(item.TipoMovimento)}</td>
                  <td className={item.QtdeCredito > 0 ? "credit-positive" : "credit-negative"}>{formatCreditAmount(item.QtdeCredito)}</td>
                  <td>{item.Observacao || "-"}</td>
                </tr>
              )) : null}
            </tbody>
          </table>
        </div>
      </article>
    </section>
  );
}

function CreditRechargeAdminScreen(props) {
  const {
    creditBalance,
    creditBalanceLoading,
    creditBalanceError,
    form,
    isSubmitting,
    error,
    message,
    onFormChange,
    onSubmit,
  } = props;
  const quantity = Number(form.QtdeCredito);
  const isQuantityValid = form.QtdeCredito !== "" && Number.isInteger(quantity) && quantity > 0;
  const hasBalance = hasValidCreditBalance(creditBalance);

  return (
    <section className="page-shell">
      <article className="content-card credit-balance-card">
        <div>
          <span className="page-eyebrow">Saldo atual</span>
          <h2>Créditos disponíveis</h2>
          <strong>{creditBalanceLoading ? "Carregando..." : hasBalance ? Number(creditBalance.SaldoCredito).toLocaleString("pt-BR") : "Indisponível"}</strong>
          <p>O saldo será atualizado após a confirmação da recarga.</p>
        </div>
      </article>

      {creditBalanceError ? <div className="feedback error">{creditBalanceError}</div> : null}

      <article className="content-card form-panel">
        <CardHeader title="Adicionar créditos" description="A operação será registrada no histórico de créditos." badge="Acesso protegido" />
        <form className="compact-crud-card" onSubmit={onSubmit}>
          <label className="field-block">
            <span>Quantidade de créditos</span>
            <input
              name="QtdeCredito"
              type="number"
              min="1"
              step="1"
              inputMode="numeric"
              value={form.QtdeCredito}
              onChange={onFormChange}
              disabled={isSubmitting}
              required
            />
          </label>
          <label className="field-block">
            <span>Observação</span>
            <textarea name="Observacao" value={form.Observacao} onChange={onFormChange} disabled={isSubmitting} />
          </label>
          {error ? <div className="feedback error">{error}</div> : null}
          {message ? <div className="feedback success">{message}</div> : null}
          <div className="crud-actions">
            <button className="primary-button" type="submit" disabled={isSubmitting || !isQuantityValid}>
              {isSubmitting ? "Recarregando..." : "Recarregar Créditos"}
            </button>
          </div>
        </form>
      </article>
    </section>
  );
}

function PrintHistoryScreen(props) {
  const {
    authUser,
    filterForm,
    historyItems,
    products,
    printers,
    layouts,
    isLoading,
    isReprinting,
    listError,
    actionError,
    actionMessage,
    onFilterChange,
    onSearch,
    onReprint,
    onRecharge,
  } = props;
  const visibleHistoryItems = historyItems.filter((item) => ![5].includes(Number(item.CdStatus || 0)));

  return (
    <section className="page-shell">
      <article className="content-card filter-card">
        <CardHeader
          title="Filtros do histórico"
          description="Filtre por produto, impressora, status e data."
          badge="Filtro"
        />

        <div className="users-filter-grid">
          <label className="field-block">
            <span>Produto</span>
            <select name="IdProduto" value={filterForm.IdProduto} onChange={onFilterChange}>
              <option value="">Todos</option>
              {products.map((product) => (
                <option key={product.IdProduto} value={product.IdProduto}>
                  {getProductLabel(product)}
                </option>
              ))}
            </select>
          </label>

          <label className="field-block">
            <span>Impressora</span>
            <select name="IdImpressora" value={filterForm.IdImpressora} onChange={onFilterChange}>
              <option value="">Todas</option>
              {printers.map((printer) => (
                <option key={printer.IdImpressora} value={printer.IdImpressora}>
                  {getPrinterLabel(printer)}
                </option>
              ))}
            </select>
          </label>

          <label className="field-block">
            <span>Status</span>
            <select name="CdStatus" value={filterForm.CdStatus} onChange={onFilterChange}>
              <option value="">Todos</option>
              <option value="1">1 - Pendente</option>
              <option value="2">2 - Impressa</option>
              <option value="3">3 - Reimpressao solicitada</option>
            </select>
          </label>

          <label className="field-block">
            <span>Informe a Data de Requisição</span>
            <input name="DataRequisicao" type="date" value={formatDateOnlyValue(filterForm.DataRequisicao)} onChange={onFilterChange} />
          </label>
        </div>

        <div className="inline-actions">
          <button className="secondary-button compact-button" type="button" onClick={onSearch} disabled={isLoading || isReprinting}>
            {isLoading ? "Pesquisando..." : "Pesquisar"}
          </button>
          <span className="inline-note">
            Sessao ativa: <strong>{authUser.Login}</strong>
          </span>
        </div>

        {listError ? <div className="feedback error">{listError}</div> : null}
        {actionError ? (
          <div className="print-history-action-error">
            <div className="feedback error">{actionError}</div>
            {isCreditRelatedError(actionError) ? <CreditRechargeActions compact onOpen={onRecharge} /> : null}
          </div>
        ) : null}
        {actionMessage ? <div className="feedback success">{actionMessage}</div> : null}
      </article>

      <article className="content-card table-panel">
        <CardHeader
          title="Histórico de Geração de Etiquetas"
          description="Acompanhe as etiquetas registradas."
          badge="Grade"
        />

        <div className="table-card">
          <table className="data-table">
            <thead>
              <tr>
                <th>Solicitação</th>
                <th>Produto</th>
                <th>Impressora</th>
                <th>Layout</th>
                <th>Lote</th>
                <th>Quantidade Requerida</th>
                <th>Quantidade Impressa</th>
                <th>Data de Requisição</th>
                <th>Data de Impressão</th>
                <th>Status</th>
                <th>Mensagem de erro</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {visibleHistoryItems.length === 0 ? (
                <tr>
                  <td colSpan="12" className="empty-state-cell">Nenhum registro encontrado com os filtros atuais.</td>
                </tr>
              ) : (
                visibleHistoryItems.map((item) => (
                  <tr key={item.IdImpressao}>
                    <td>{item.IdImpressao}</td>
                    <td>{getProductLabel(products.find((product) => Number(product.IdProduto) === Number(item.IdProduto)))}</td>
                    <td>{getPrinterLabel(printers.find((printer) => Number(printer.IdImpressora) === Number(item.IdImpressora)))}</td>
                    <td>{getLayoutLabel(layouts.find((layout) => Number(layout.IdLayoutImpressao) === Number(item.IdLayoutImpressao)))}</td>
                    <td>{item.CodLote || "-"}</td>
                    <td>{item.QtdeRequerida}</td>
                    <td>{item.QtdeImpressa}</td>
                    <td>{formatTimestampLabel(item.DataRequisicao)}</td>
                    <td>{formatTimestampLabel(item.DataImpressao)}</td>
                    <td>
                      <span className={`status-chip ${item.CdStatus === 2 ? "success" : item.CdStatus === 3 ? "warning" : item.CdStatus === 4 ? "danger" : "neutral"}`}>
                        {getPrintStatusLabel(item.CdStatus)}
                      </span>
                    </td>
                    <td>{item.MensagemErro || "-"}</td>
                    <td>
                      <button
                        className="secondary-button compact-button"
                        type="button"
                        onClick={() => onReprint(item)}
                        disabled={isLoading || isReprinting}
                      >
                        Reimprimir
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </article>
    </section>
  );
}

function TenantScreen(props) {
  const {
    tenants,
    tenantForm,
    isLoading,
    isSaving,
    listError,
    saveError,
    saveMessage,
    singletonWarning,
    onSearch,
    onEdit,
    onFormChange,
    onSubmit,
    onReset,
  } = props;

  return (
    <section className="page-shell">
      <article className="content-card form-panel compact-crud-card">
        <CardHeader
          title="Dados da configuracao"
          description="Configure os dados principais do ambiente."
        />

        <form className="crud-form-grid" onSubmit={onSubmit}>
          <label className="field-block">
            <span>Nome de exibição</span>
            <input name="NomeFantasia" type="text" value={tenantForm.NomeFantasia} onChange={onFormChange} placeholder="Nome de exibição do ambiente" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>Razão Social</span>
            <input name="RazaoSocial" type="text" value={tenantForm.RazaoSocial} onChange={onFormChange} placeholder="Razão social do ambiente" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>CNPJ</span>
            <input name="CNPJ" type="text" value={tenantForm.CNPJ} onChange={onFormChange} placeholder="CNPJ" disabled={isSaving} />
          </label>

          <label className="field-block full-width">
            <span>Logo do Tenant</span>
            <input name="NomeArquivoLogo" type="text" value={tenantForm.NomeArquivoLogo} onChange={onFormChange} placeholder="Nome do arquivo de logo do Tenant" disabled={isSaving} />
          </label>

          <label className="field-block">
            <span>CorPrincipal</span>
            <div className="color-row">
              <input name="CorPrincipal" type="text" value={tenantForm.CorPrincipal} onChange={onFormChange} placeholder={DEFAULT_PRIMARY_COLOR} disabled={isSaving} />
              <input name="CorPrincipal" type="color" value={tenantForm.CorPrincipal || DEFAULT_PRIMARY_COLOR} onChange={onFormChange} disabled={isSaving} />
            </div>
          </label>

          <label className="field-block">
            <span>CorDestaque</span>
            <div className="color-row">
              <input name="CorDestaque" type="text" value={tenantForm.CorDestaque} onChange={onFormChange} placeholder={DEFAULT_ACCENT_COLOR} disabled={isSaving} />
              <input name="CorDestaque" type="color" value={tenantForm.CorDestaque || DEFAULT_ACCENT_COLOR} onChange={onFormChange} disabled={isSaving} />
            </div>
          </label>

          <label className="field-block">
            <span>Status</span>
            <select name="CdStatus" value={tenantForm.CdStatus} onChange={onFormChange} disabled={isSaving}>
              <option value="">Todos</option>
              <option value="1">1</option>
              <option value="0">0</option>
            </select>
          </label>

          {saveError ? <div className="feedback error full-width">{saveError}</div> : null}
          {saveMessage ? <div className="feedback success full-width">{saveMessage}</div> : null}

          <div className="crud-actions full-width">
            <button className="primary-button compact-button" type="submit" disabled={isSaving}>
              {isSaving ? "Salvando..." : "Salvar configuracao"}
            </button>
            <button className="secondary-button compact-button" type="button" onClick={onReset} disabled={isSaving}>
              Limpar
            </button>
            <button className="secondary-button compact-button" type="button" onClick={onSearch} disabled={isLoading || isSaving}>
              {isLoading ? "Pesquisando..." : "Pesquisar"}
            </button>
          </div>

          <div className="content-card field-reference-card full-width">
            <div className="section-heading">
              <span>Identidade</span>
              <h2>Identidade do Tenant</h2>
            </div>

            <div
              className="tenant-preview-card"
              style={{
                background: `linear-gradient(135deg, ${tenantForm.CorPrincipal || DEFAULT_PRIMARY_COLOR}, ${tenantForm.CorDestaque || DEFAULT_ACCENT_COLOR})`,
              }}
            >
              <div className="brand">
                <div className="brand-logo">SP</div>
                <div>
                  <strong>{tenantForm.NomeFantasia || DEFAULT_BRAND_NAME}</strong>
                  <span>{tenantForm.RazaoSocial || "Identidade visual do ambiente"}</span>
                </div>
              </div>
              <p>{tenantForm.NomeArquivoLogo ? `Logo: ${tenantForm.NomeArquivoLogo}` : "Nenhum logo informado."}</p>
              <div className="hero-badges">
                <span className="hero-badge">{tenantForm.CNPJ || "CNPJ Não informado"}</span>
                <span className="hero-badge">Status {tenantForm.CdStatus || 0}</span>
              </div>
            </div>
          </div>
        </form>
      </article>

      <article className="content-card table-panel crud-table-panel">
        <CardHeader title="configuração atual" description="O sistema utiliza apenas uma configuração." />

        {listError ? <div className="feedback error">{listError}</div> : null}
        {singletonWarning ? <div className="feedback error">{singletonWarning}</div> : null}

        {tenants.length === 0 ? (
          <div className="empty-state-card">
            Nenhuma configuracao encontrada.
          </div>
        ) : (
          <div className="tenant-summary-list">
            {tenants.map((tenant) => (
              <button key={tenant.IdTenant} type="button" className="tenant-summary-card" onClick={() => onEdit(tenant)}>
                <div className="tenant-swatch-row">
                  <span className="tenant-swatch" style={{ background: tenant.CorPrincipal || DEFAULT_PRIMARY_COLOR }} />
                  <span className="tenant-swatch" style={{ background: tenant.CorDestaque || DEFAULT_ACCENT_COLOR }} />
                </div>
                <strong>{tenant.NomeFantasia || "configuração sem nome"}</strong>
                <small>{tenant.RazaoSocial || "Razão social Não informada"}</small>
                <span className="page-badge subtle">Status {tenant.CdStatus || 0}</span>
              </button>
            ))}
          </div>
        )}
      </article>
    </section>
  );
}

export default function App() {
  const [activeRoute, setActiveRoute] = useState(() => getRouteFromHash());
  const [authUser, setAuthUser] = useState(() => readAuthSession());
  const [activeTenant, setActiveTenant] = useState(() => readStoredTenant());
  const [tenantThemeLoaded, setTenantThemeLoaded] = useState(() => Boolean(readStoredTenant()));
  const [loginForm, setLoginForm] = useState({ Login: "", Senha: "" });
  const [loginShowPassword, setLoginShowPassword] = useState(false);
  const [loginError, setLoginError] = useState("");
  const [termsError, setTermsError] = useState("");
  const [termsHtml, setTermsHtml] = useState("");
  const [isTermsLoading, setIsTermsLoading] = useState(false);
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);
  const [isCreditRechargeDialogOpen, setIsCreditRechargeDialogOpen] = useState(false);
  const [isLoginSubmitting, setIsLoginSubmitting] = useState(false);
  const [isTermsSubmitting, setIsTermsSubmitting] = useState(false);
  const [dashboardItems, setDashboardItems] = useState([]);
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [dashboardError, setDashboardError] = useState("");
  const [creditBalance, setCreditBalance] = useState(null);
  const [creditBalanceLoading, setCreditBalanceLoading] = useState(false);
  const [creditBalanceError, setCreditBalanceError] = useState("");
  const [creditHistory, setCreditHistory] = useState([]);
  const [creditHistoryLoading, setCreditHistoryLoading] = useState(false);
  const [creditHistoryError, setCreditHistoryError] = useState("");
  const [creditHistoryFilter, setCreditHistoryFilter] = useState(DEFAULT_CREDIT_HISTORY_FILTER);
  const [creditHistoryLoaded, setCreditHistoryLoaded] = useState(false);
  const [creditRechargeForm, setCreditRechargeForm] = useState(DEFAULT_CREDIT_RECHARGE_FORM);
  const [creditRechargeSubmitting, setCreditRechargeSubmitting] = useState(false);
  const [creditRechargeError, setCreditRechargeError] = useState("");
  const [creditRechargeMessage, setCreditRechargeMessage] = useState("");

  const [userFilterForm, setUserFilterForm] = useState(DEFAULT_USER_FILTER);
  const [userForm, setUserForm] = useState(DEFAULT_USER_FORM);
  const [users, setUsers] = useState([]);
  const [usersLoaded, setUsersLoaded] = useState(false);
  const [usersLoading, setUsersLoading] = useState(false);
  const [usersSaving, setUsersSaving] = useState(false);
  const [usersListError, setUsersListError] = useState("");
  const [usersSaveError, setUsersSaveError] = useState("");
  const [usersSaveMessage, setUsersSaveMessage] = useState("");

  const [productFilterForm, setProductFilterForm] = useState(DEFAULT_PRODUCT_FILTER);
  const [productForm, setProductForm] = useState(DEFAULT_PRODUCT_FORM);
  const [products, setProducts] = useState([]);
  const [productsLoaded, setProductsLoaded] = useState(false);
  const [productsLoading, setProductsLoading] = useState(false);
  const [productsSaving, setProductsSaving] = useState(false);
  const [productsListError, setProductsListError] = useState("");
  const [productsSaveError, setProductsSaveError] = useState("");
  const [productsSaveMessage, setProductsSaveMessage] = useState("");
  const [isProductNutritionOpen, setIsProductNutritionOpen] = useState(false);
  const [productNutritionItems, setProductNutritionItems] = useState([]);
  const [productNutritionLoading, setProductNutritionLoading] = useState(false);
  const [productNutritionSaving, setProductNutritionSaving] = useState(false);
  const [productNutritionError, setProductNutritionError] = useState("");
  const [productNutritionMessage, setProductNutritionMessage] = useState("");

  const [clientFilterForm, setClientFilterForm] = useState(DEFAULT_CLIENT_FILTER);
  const [clientForm, setClientForm] = useState(DEFAULT_CLIENT_FORM);
  const [clients, setClients] = useState([]);
  const [clientsLoaded, setClientsLoaded] = useState(false);
  const [clientsLoading, setClientsLoading] = useState(false);
  const [clientsSaving, setClientsSaving] = useState(false);
  const [clientsListError, setClientsListError] = useState("");
  const [clientsSaveError, setClientsSaveError] = useState("");
  const [clientsSaveMessage, setClientsSaveMessage] = useState("");

  const [printerFilterForm, setPrinterFilterForm] = useState(DEFAULT_PRINTER_FILTER);
  const [printerForm, setPrinterForm] = useState(DEFAULT_PRINTER_FORM);
  const [printers, setPrinters] = useState([]);
  const [printersLoaded, setPrintersLoaded] = useState(false);
  const [printersLoading, setPrintersLoading] = useState(false);
  const [printersSaving, setPrintersSaving] = useState(false);
  const [printersListError, setPrintersListError] = useState("");
  const [printersSaveError, setPrintersSaveError] = useState("");
  const [printersSaveMessage, setPrintersSaveMessage] = useState("");

  const [layoutFilterForm, setLayoutFilterForm] = useState(DEFAULT_LAYOUT_FILTER);
  const [layoutForm, setLayoutForm] = useState(DEFAULT_LAYOUT_FORM);
  const [layoutFields, setLayoutFields] = useState(buildLayoutFields());
  const [layouts, setLayouts] = useState([]);
  const [layoutsLoaded, setLayoutsLoaded] = useState(false);
  const [layoutsLoading, setLayoutsLoading] = useState(false);
  const [layoutsSaving, setLayoutsSaving] = useState(false);
  const [layoutsListError, setLayoutsListError] = useState("");
  const [layoutsSaveError, setLayoutsSaveError] = useState("");
  const [layoutsSaveMessage, setLayoutsSaveMessage] = useState("");

  const [printRequestForm, setPrintRequestForm] = useState(DEFAULT_PRINT_REQUEST_FORM);
  const [productTypes] = useState(OFFICIAL_PRODUCT_TYPES);
  const [printProducts, setPrintProducts] = useState([]);
  const [activeClients, setActiveClients] = useState([]);
  const [printLayouts, setPrintLayouts] = useState([]);
  const [printPrinters, setPrintPrinters] = useState([]);
  const [activePrintFields] = useState(OFFICIAL_PRINT_FIELDS);
  const [printOptionsLoaded, setPrintOptionsLoaded] = useState(false);
  const [printOptionsLoading, setPrintOptionsLoading] = useState(false);
  const [printOptionsError, setPrintOptionsError] = useState("");
  const [printSubmitting, setPrintSubmitting] = useState(false);
  const [printSubmitError, setPrintSubmitError] = useState("");
  const [printSubmitMessage, setPrintSubmitMessage] = useState("");
  const [lastPrintResult, setLastPrintResult] = useState(null);
  const [printHistoryFilterForm, setPrintHistoryFilterForm] = useState(DEFAULT_PRINT_HISTORY_FILTER);
  const [printHistoryItems, setPrintHistoryItems] = useState([]);
  const [printHistoryLoaded, setPrintHistoryLoaded] = useState(false);
  const [printHistoryLoading, setPrintHistoryLoading] = useState(false);
  const [printHistoryReprinting, setPrintHistoryReprinting] = useState(false);
  const [printHistoryListError, setPrintHistoryListError] = useState("");
  const [printHistoryActionError, setPrintHistoryActionError] = useState("");
  const [printHistoryActionMessage, setPrintHistoryActionMessage] = useState("");
  const [tenantFilterForm, setTenantFilterForm] = useState(DEFAULT_TENANT_FILTER);
  const [tenantForm, setTenantForm] = useState(DEFAULT_TENANT_FORM);
  const [tenants, setTenants] = useState([]);
  const [tenantLoaded, setTenantLoaded] = useState(false);
  const [tenantLoading, setTenantLoading] = useState(false);
  const [tenantSaving, setTenantSaving] = useState(false);
  const [tenantListError, setTenantListError] = useState("");
  const [tenantSaveError, setTenantSaveError] = useState("");
  const [tenantSaveMessage, setTenantSaveMessage] = useState("");
  const [tenantSingletonWarning, setTenantSingletonWarning] = useState("");
  const tenantName = getTenantDisplayName(activeTenant);
  const tenantSocialReason = getTenantSocialReason(activeTenant);
  const tenantInitials = getTenantInitials(tenantName);
  const tenantLogoUrl = resolveTenantLogoUrl(activeTenant?.NomeArquivoLogo);

  useEffect(() => {
    const handleHashChange = () => {
      setActiveRoute(getRouteFromHash());
      setAuthUser(readAuthSession());
      setActiveTenant(readStoredTenant());
    };

    window.addEventListener("hashchange", handleHashChange);
    window.addEventListener("storage", handleHashChange);

    if (!window.location.hash) {
      window.location.hash = "/dashboard";
    }

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
      window.removeEventListener("storage", handleHashChange);
    };
  }, []);

  useEffect(() => {
    applyTenantTheme(activeTenant);
    setTenantThemeLoaded(true);
  }, [activeTenant]);

  useEffect(() => {
    let isCurrentRequest = true;

    const loadTerms = async () => {
      if (!authUser?.JwtToken || resolveFlag(authUser.TermsUse) === 1) {
        if (isCurrentRequest) {
          setTermsHtml("");
          setTermsError("");
          setHasAcceptedTerms(false);
        }
        return;
      }

      setIsTermsLoading(true);
      setTermsError("");
      setTermsHtml("");
      setHasAcceptedTerms(false);

      try {
        const { response, payload } = await postJson("/api/User/GetTerms", {}, authUser.JwtToken);
        const textoTermo = pickValue(getApiSource(payload), "TextoTermo", "textoTermo", "");

        if (!response.ok || !textoTermo) {
          throw new Error(pickValue(getApiSource(payload), "Mensagem", "mensagem", "Nao foi possivel carregar o Termo de Uso."));
        }

        if (isCurrentRequest) {
          setTermsHtml(textoTermo);
        }
      } catch (error) {
        if (isCurrentRequest) {
          setTermsError(error.message || "Nao foi possivel carregar o Termo de Uso.");
        }
      } finally {
        if (isCurrentRequest) {
          setIsTermsLoading(false);
        }
      }
    };

    loadTerms();

    return () => {
      isCurrentRequest = false;
    };
  }, [authUser?.JwtToken, authUser?.TermsUse]);

  const isProtectedAdmin = authUser?.IsAdmin === 1 && Number(authUser?.IdUsuario) === 1;

  const visibleRoutes = useMemo(() => {
    const isAdmin = authUser?.IsAdmin === 1;
    return ROUTES.filter((route) =>
      (!route.requiresAdmin || isAdmin) && (!route.requiresProtectedAdmin || isProtectedAdmin)
    );
  }, [authUser, isProtectedAdmin]);

  const activeScreen = useMemo(() => {
    return visibleRoutes.find((route) => route.key === activeRoute) || visibleRoutes[0] || ROUTES[0];
  }, [activeRoute, visibleRoutes]);

  const subtitle = authUser
    ? authUser.IsAdmin === 1
      ? "Perfil administrador"
      : "Perfil operacional"
    : "Sessao encerrada";

  const isEditingUser = Number(userForm.IdUsuario || 0) > 0;
  const isEditingProduct = Number(productForm.IdProduto || 0) > 0;
  const isEditingClient = Number(clientForm.IdCliente || 0) > 0;
  const isEditingPrinter = Number(printerForm.IdImpressora || 0) > 0;
  const isEditingLayout = Number(layoutForm.IdLayoutImpressao || 0) > 0;

  const loadActiveTenant = async (token = null) => {
    try {
      const { response, payload } = await postJson(
        "/api/Tenant/FilterTenant",
        {
          NomeFantasia: null,
          RazaoSocial: null,
          CNPJ: null,
          NomeArquivoLogo: null,
          CorPrincipal: null,
          CorDestaque: null,
          CdStatus: 1,
        },
        token
      );

      if (!response.ok || !Array.isArray(payload)) {
        return null;
      }

      const nextActiveTenant = payload
        .map(normalizeTenantDto)
        .find((tenant) => Number(tenant.CdStatus) === 1);

      if (!nextActiveTenant) {
        return null;
      }

      const normalizedTenant = saveTenantTheme(nextActiveTenant);
      setActiveTenant(normalizedTenant);
      return normalizedTenant;
    } catch (error) {
      return null;
    } finally {
      setTenantThemeLoaded(true);
    }
  };

  const loadUsers = async (nextFilter = userFilterForm) => {
    if (!authUser?.JwtToken) {
      return;
    }

    setUsersLoading(true);
    setUsersListError("");

    try {
      const { response, payload } = await postJson(
        "/api/User/FilterUser",
        {
          Login: nextFilter.Login.trim() || null,
          IsAdmin: toNullableSelectFilter(nextFilter.IsAdmin),
          IsBlocked: toNullableSelectFilter(nextFilter.IsBlocked),
          CdStatus: toNullableSelectFilter(nextFilter.CdStatus),
          TermsUse: toNullableSelectFilter(nextFilter.TermsUse),
        },
        authUser.JwtToken
      );

      if (!response.ok || !Array.isArray(payload)) {
        setUsersListError("Nao foi possivel carregar a lista de usuarios.");
        return;
      }

      setUsers(payload.map(normalizeUserDto));
      setUsersLoaded(true);
    } catch (error) {
      setUsersListError("Falha ao carregar usuarios.");
    } finally {
      setUsersLoading(false);
    }
  };

  const loadProducts = async (nextFilter = productFilterForm) => {
    if (!authUser?.JwtToken) {
      return;
    }

    setProductsLoading(true);
    setProductsListError("");

    try {
      const { response, payload } = await postJson(
        "/api/Product/FilterProduct",
        {
          CodigoBaseProduto: nextFilter.CodigoBaseProduto.trim() || null,
          CodBarras: nextFilter.CodBarras.trim() || null,
          Descricao: nextFilter.Descricao.trim() || null,
          IdTipoProduto: toNullableSelectFilter(nextFilter.IdTipoProduto),
          CdStatus: toNullableSelectFilter(nextFilter.CdStatus),
        },
        authUser.JwtToken
      );

      if (!response.ok || !Array.isArray(payload)) {
        setProductsListError("Nao foi possivel carregar a lista de produtos.");
        return;
      }

      setProducts(payload.map(normalizeProductDto));
      setProductsLoaded(true);
    } catch (error) {
      setProductsListError("Falha ao carregar produtos.");
    } finally {
      setProductsLoading(false);
    }
  };

  const loadClients = async (nextFilter = clientFilterForm) => {
    if (!authUser?.JwtToken) {
      return;
    }

    setClientsLoading(true);
    setClientsListError("");

    try {
      const { response, payload } = await postJson(
        "/api/Client/FilterClient",
        {
          CNPJ: nextFilter.CNPJ.trim() || null,
          RazaoSocial: nextFilter.RazaoSocial.trim() || null,
          NomeFantasia: nextFilter.NomeFantasia.trim() || null,
          EnderecoCompleto: nextFilter.EnderecoCompleto.trim() || null,
          CdStatus: toNullableSelectFilter(nextFilter.CdStatus),
        },
        authUser.JwtToken
      );

      if (!response.ok || !Array.isArray(payload)) {
        setClientsListError("Nao foi possivel carregar a lista de clientes.");
        return;
      }

      setClients(payload.map(normalizeClientDto));
      setClientsLoaded(true);
    } catch (error) {
      setClientsListError("Falha ao carregar clientes.");
    } finally {
      setClientsLoading(false);
    }
  };

  const loadPrinters = async (nextFilter = printerFilterForm) => {
    if (!authUser?.JwtToken) {
      return;
    }

    setPrintersLoading(true);
    setPrintersListError("");

    try {
      const { response, payload } = await postJson(
        "/api/Printer/FilterPrinter",
        {
          CodigoImpressora: nextFilter.CodigoImpressora.trim() || null,
          NomeRede: nextFilter.NomeRede.trim() || null,
          NomeComputadorRede: nextFilter.NomeComputadorRede.trim() || null,
          Marca: nextFilter.Marca.trim() || null,
          Modelo: nextFilter.Modelo.trim() || null,
          Apelido: nextFilter.Apelido.trim() || null,
          CdStatus: toNullableSelectFilter(nextFilter.CdStatus),
        },
        authUser.JwtToken
      );

      if (!response.ok || !Array.isArray(payload)) {
        setPrintersListError("Nao foi possivel carregar a lista de impressoras.");
        return;
      }

      setPrinters(payload.map(normalizePrinterDto));
      setPrintersLoaded(true);
    } catch (error) {
      setPrintersListError("Falha ao carregar impressoras.");
    } finally {
      setPrintersLoading(false);
    }
  };

  const loadLayouts = async (nextFilter = layoutFilterForm) => {
    if (!authUser?.JwtToken) {
      return;
    }

    setLayoutsLoading(true);
    setLayoutsListError("");

    try {
      const { response, payload } = await postJson(
        "/api/PrintLayout/FilterPrintLayout",
        {
          CodigoLayout: nextFilter.CodigoLayout.trim() || null,
          Descricao: nextFilter.Descricao.trim() || null,
          CdStatus: toNullableSelectFilter(nextFilter.CdStatus),
        },
        authUser.JwtToken
      );

      if (!response.ok || !Array.isArray(payload)) {
        setLayoutsListError("Nao foi possivel carregar a lista de layouts.");
        return;
      }

      setLayouts(payload.map(normalizeLayoutDto));
      setLayoutsLoaded(true);
    } catch (error) {
      setLayoutsListError("Falha ao carregar layouts.");
    } finally {
      setLayoutsLoading(false);
    }
  };

  const loadPrintOptions = async () => {
    if (!authUser?.JwtToken) {
      return;
    }

    setPrintOptionsLoading(true);
    setPrintOptionsError("");

    try {
      const [productResponse, clientResponse, printerResponse, layoutResponse] = await Promise.all([
        postJson(
          "/api/Product/FilterProduct",
          {
            CodigoBaseProduto: null,
            CodBarras: null,
            Descricao: null,
            IdTipoProduto: null,
            CdStatus: 1,
          },
          authUser.JwtToken
        ),
        postJson(
          "/api/Client/FilterClient",
          {
            CNPJ: null,
            RazaoSocial: null,
            NomeFantasia: null,
            EnderecoCompleto: null,
            CdStatus: 1,
          },
          authUser.JwtToken
        ),
        postJson(
          "/api/Printer/FilterPrinter",
          {
            CodigoImpressora: null,
            NomeRede: null,
            NomeComputadorRede: null,
            Marca: null,
            Modelo: null,
            Apelido: null,
            CdStatus: 1,
          },
          authUser.JwtToken
        ),
        postJson(
          "/api/PrintLayout/FilterPrintLayout",
          {
            CodigoLayout: null,
            Descricao: null,
            CdStatus: 1,
          },
          authUser.JwtToken
        ),
      ]);

      if (
        !productResponse.response.ok ||
        !clientResponse.response.ok ||
        !printerResponse.response.ok ||
        !layoutResponse.response.ok ||
        !Array.isArray(productResponse.payload) ||
        !Array.isArray(clientResponse.payload) ||
        !Array.isArray(printerResponse.payload) ||
        !Array.isArray(layoutResponse.payload)
      ) {
        setPrintOptionsError("Nao foi possivel carregar as opcoes da impressao.");
        return;
      }

      setPrintProducts(productResponse.payload.map(normalizeProductDto));
      setActiveClients(clientResponse.payload.map(normalizeClientDto));
      setPrintPrinters(printerResponse.payload.map(normalizePrinterDto));
      setPrintLayouts(layoutResponse.payload.map(normalizeLayoutDto));
      setPrintOptionsLoaded(true);
    } catch (error) {
      setPrintOptionsError("Falha ao carregar as opcoes da impressao.");
    } finally {
      setPrintOptionsLoading(false);
    }
  };

  const loadPrintHistory = async (nextFilter = printHistoryFilterForm) => {
    if (!authUser?.JwtToken) {
      return;
    }

    setPrintHistoryLoading(true);
    setPrintHistoryListError("");

    try {
      const { response, payload } = await postJson(
        "/api/PrintManagement/FilterPrintHistory",
        {
          IdProduto: nextFilter.IdProduto === "" ? 0 : Number(nextFilter.IdProduto),
          IdImpressora: nextFilter.IdImpressora === "" ? 0 : Number(nextFilter.IdImpressora),
          CdStatus: nextFilter.CdStatus === "" ? 0 : Number(nextFilter.CdStatus),
          DataRequisicao: toTimestampValue(nextFilter.DataRequisicao),
        },
        authUser.JwtToken
      );

      if (!response.ok || !Array.isArray(payload)) {
        setPrintHistoryListError("Nao foi possivel carregar o historico de impressao.");
        return;
      }

      setPrintHistoryItems(payload.map(normalizePrintManagementDto));
      setPrintHistoryLoaded(true);
    } catch (error) {
      setPrintHistoryListError("Falha ao carregar o historico de impressao.");
    } finally {
      setPrintHistoryLoading(false);
    }
  };

  const loadDashboard = React.useCallback(async () => {
    if (!authUser?.JwtToken) {
      return;
    }

    setDashboardLoading(true);
    setDashboardError("");

    try {
      const { response, payload } = await postJson(
        "/api/PrintManagement/FilterPrintHistory",
        {
          IdProduto: 0,
          IdImpressora: 0,
          CdStatus: 0,
          DataRequisicao: null,
        },
        authUser.JwtToken
      );

      if (!response.ok || !Array.isArray(payload)) {
        setDashboardError("Nao foi possivel carregar os indicadores do dashboard.");
        return;
      }

      setDashboardItems(payload.map(normalizePrintManagementDto));
    } catch (error) {
      setDashboardError("Falha ao carregar o dashboard.");
    } finally {
      setDashboardLoading(false);
    }
  }, [authUser?.JwtToken]);

  const loadCreditBalance = React.useCallback(async () => {
    if (!authUser?.JwtToken || authUser.TermsUse !== 1) {
      return;
    }

    setCreditBalanceLoading(true);
    setCreditBalanceError("");

    try {
      const { response, payload } = await postJson("/api/Credit/GetBalance", {}, authUser.JwtToken);
      const normalized = normalizeCreditBalanceDto(payload);
      const hasValidBalance = normalized.SaldoCredito !== null && normalized.CustoCreditoImpressao !== null && Number.isInteger(Number(normalized.SaldoCredito)) && Number.isInteger(Number(normalized.CustoCreditoImpressao)) && Number(normalized.CustoCreditoImpressao) > 0;

      if (!response.ok || !hasValidBalance) {
        setCreditBalance(null);
        setCreditBalanceError(normalized.Mensagem || pickValue(payload, "Mensagem", "mensagem", "Nao foi possivel consultar o saldo de créditos."));
        return;
      }

      setCreditBalance(normalized);
    } catch (error) {
      setCreditBalance(null);
      setCreditBalanceError("Falha ao consultar o saldo de créditos.");
    } finally {
      setCreditBalanceLoading(false);
    }
  }, [authUser?.JwtToken, authUser?.TermsUse]);

  const refreshDashboard = React.useCallback(async () => {
    await Promise.all([loadDashboard(), loadCreditBalance()]);
  }, [loadDashboard, loadCreditBalance]);

  const loadCreditHistory = async (nextFilter = creditHistoryFilter) => {
    if (!authUser?.JwtToken || authUser.TermsUse !== 1) {
      return;
    }

    setCreditHistoryLoading(true);
    setCreditHistoryError("");

    try {
      const { response, payload } = await postJson(
        "/api/Credit/GetHistory",
        {
          DataInicial: toTimestampValue(nextFilter.DataInicial),
          DataFinal: toTimestampValue(nextFilter.DataFinal),
          TipoMovimento: nextFilter.TipoMovimento || null,
        },
        authUser.JwtToken
      );

      if (!response.ok || !Array.isArray(payload)) {
        setCreditHistoryError(pickValue(payload, "Mensagem", "mensagem", "Nao foi possivel carregar o histórico de créditos."));
        return;
      }

      setCreditHistory(payload.map(normalizeCreditHistoryDto));
      setCreditHistoryLoaded(true);
    } catch (error) {
      setCreditHistoryError("Falha ao carregar o histórico de créditos.");
    } finally {
      setCreditHistoryLoading(false);
    }
  };

  const loadTenant = async (nextFilter = tenantFilterForm) => {
    if (!authUser?.JwtToken || authUser?.IsAdmin !== 1) {
      return;
    }

    setTenantLoading(true);
    setTenantListError("");
    setTenantSingletonWarning("");

    try {
      const { response, payload } = await postJson(
        "/api/Tenant/FilterTenant",
        {
          NomeFantasia: nextFilter.NomeFantasia.trim() || null,
          RazaoSocial: nextFilter.RazaoSocial.trim() || null,
          CNPJ: nextFilter.CNPJ.trim() || null,
          NomeArquivoLogo: nextFilter.NomeArquivoLogo.trim() || null,
          CorPrincipal: nextFilter.CorPrincipal.trim() || null,
          CorDestaque: nextFilter.CorDestaque.trim() || null,
          CdStatus: toNullableSelectFilter(nextFilter.CdStatus),
        },
        authUser.JwtToken
      );

      if (!response.ok || !Array.isArray(payload)) {
        setTenantListError("Nao foi possivel carregar a configuracao do tenant.");
        return;
      }

      const normalizedTenants = payload.map(normalizeTenantDto);
      const selectedTenant = normalizedTenants[0] || null;

      if (normalizedTenants.length > 1) {
        setTenantSingletonWarning("Existe mais de uma configuracao cadastrada. O sistema utilizara a primeira.");
      }

      setTenants(selectedTenant ? [selectedTenant] : []);
      setTenantLoaded(true);

      if (selectedTenant) {
        setTenantForm({
          IdTenant: selectedTenant.IdTenant || 0,
          NomeFantasia: selectedTenant.NomeFantasia || "",
          RazaoSocial: selectedTenant.RazaoSocial || "",
          CNPJ: selectedTenant.CNPJ || "",
          NomeArquivoLogo: selectedTenant.NomeArquivoLogo || "",
          CorPrincipal: selectedTenant.CorPrincipal || DEFAULT_PRIMARY_COLOR,
          CorDestaque: selectedTenant.CorDestaque || DEFAULT_ACCENT_COLOR,
          CdStatus: selectedTenant.CdStatus || 1,
        });
      } else {
        setTenantForm(DEFAULT_TENANT_FORM);
      }

    } catch (error) {
      setTenantListError("Falha ao carregar as configuracoes.");
    } finally {
      setTenantLoading(false);
    }
  };

  useEffect(() => {
    if (activeRoute === "dashboard" && authUser?.JwtToken && authUser.TermsUse === 1) {
      refreshDashboard();
    }
  }, [activeRoute, authUser?.JwtToken, authUser?.TermsUse, refreshDashboard]);

  useEffect(() => {
    if (authUser?.JwtToken && authUser.TermsUse === 1) {
      loadCreditBalance();
      return;
    }

    setCreditBalance(null);
    setCreditBalanceError("");
  }, [authUser?.JwtToken, authUser?.TermsUse]);

  useEffect(() => {
    if (activeRoute === "creditos" && authUser?.JwtToken && authUser.TermsUse === 1 && !creditHistoryLoaded && !creditHistoryLoading) {
      loadCreditHistory();
      return;
    }

    if (activeRoute !== "creditos" && creditHistoryLoaded) {
      setCreditHistoryLoaded(false);
    }
  }, [activeRoute, authUser?.JwtToken, authUser?.TermsUse, creditHistoryLoaded, creditHistoryLoading]);

  useEffect(() => {
    if (activeRoute === "usuarios" && authUser?.JwtToken && authUser.TermsUse === 1 && !usersLoaded && !usersLoading) {
      loadUsers();
    }
  }, [activeRoute, authUser, usersLoaded, usersLoading]);

  useEffect(() => {
    if (activeRoute === "produtos" && authUser?.JwtToken && authUser.TermsUse === 1 && !productsLoaded && !productsLoading) {
      loadProducts();
    }
  }, [activeRoute, authUser, productsLoaded, productsLoading]);

  useEffect(() => {
    if (activeRoute === "clientes" && authUser?.JwtToken && authUser.TermsUse === 1 && !clientsLoaded && !clientsLoading) {
      loadClients();
    }
  }, [activeRoute, authUser, clientsLoaded, clientsLoading]);

  useEffect(() => {
    if (activeRoute === "impressoras" && authUser?.JwtToken && authUser.TermsUse === 1 && !printersLoaded && !printersLoading) {
      loadPrinters();
    }
  }, [activeRoute, authUser, printersLoaded, printersLoading]);

  useEffect(() => {
    if (activeRoute === "layouts" && authUser?.JwtToken && authUser.TermsUse === 1 && !layoutsLoaded && !layoutsLoading) {
      loadLayouts();
    }
  }, [activeRoute, authUser, layoutsLoaded, layoutsLoading]);

  useEffect(() => {
    if (activeRoute === "impressao" && authUser?.JwtToken && authUser.TermsUse === 1 && !printOptionsLoaded && !printOptionsLoading) {
      loadPrintOptions();
    }
  }, [activeRoute, authUser, printOptionsLoaded, printOptionsLoading]);

  useEffect(() => {
    if (activeRoute === "historico" && authUser?.JwtToken && authUser.TermsUse === 1 && !printOptionsLoaded && !printOptionsLoading) {
      loadPrintOptions();
    }
  }, [activeRoute, authUser, printOptionsLoaded, printOptionsLoading]);

  useEffect(() => {
    if (activeRoute === "historico" && authUser?.JwtToken && authUser.TermsUse === 1 && !printHistoryLoaded && !printHistoryLoading) {
      loadPrintHistory();
      return;
    }

    if (activeRoute !== "historico" && printHistoryLoaded) {
      setPrintHistoryLoaded(false);
    }
  }, [activeRoute, authUser?.JwtToken, authUser?.TermsUse, printHistoryLoaded, printHistoryLoading]);

  useEffect(() => {
    if (activeRoute === "tenant" && authUser?.JwtToken && authUser.IsAdmin === 1 && authUser.TermsUse === 1 && !tenantLoaded && !tenantLoading) {
      loadTenant();
    }
  }, [activeRoute, authUser, tenantLoaded, tenantLoading]);

  useEffect(() => {
    if (!tenantThemeLoaded) {
      const storedTenant = readStoredTenant();

      if (storedTenant) {
        setActiveTenant(storedTenant);
      }
    }

    loadActiveTenant();
  }, []);

  useEffect(() => {
    if (authUser?.JwtToken) {
      loadActiveTenant(authUser.JwtToken);
    }
  }, [authUser?.JwtToken]);

  const handleLoginFieldChange = (event) => {
    const { name, value } = event.target;
    setLoginForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleToggleLoginPassword = () => {
    setLoginShowPassword((current) => !current);
  };

  const handleUserFilterChange = (event) => {
    const { name, value } = event.target;
    setUserFilterForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleUserFormChange = (event) => {
    const { name, value } = event.target;
    setUsersSaveError("");
    setUsersSaveMessage("");
    setUserForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleProductFilterChange = (event) => {
    const { name, value } = event.target;
    setProductFilterForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleProductFormChange = (event) => {
    const { name, value } = event.target;
    setProductsSaveError("");
    setProductsSaveMessage("");
    setProductForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleClientFilterChange = (event) => {
    const { name, value } = event.target;
    setClientFilterForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleClientFormChange = (event) => {
    const { name, value } = event.target;
    setClientsSaveError("");
    setClientsSaveMessage("");
    setClientForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handlePrinterFilterChange = (event) => {
    const { name, value } = event.target;
    setPrinterFilterForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handlePrinterFormChange = (event) => {
    const { name, value } = event.target;
    setPrintersSaveError("");
    setPrintersSaveMessage("");
    setPrinterForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleLayoutFilterChange = (event) => {
    const { name, value } = event.target;
    setLayoutFilterForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleLayoutFormChange = (event) => {
    const { name, value } = event.target;
    setLayoutsSaveError("");
    setLayoutsSaveMessage("");
    setLayoutForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleLayoutFieldChange = (index, name, value) => {
    setLayoutsSaveError("");
    setLayoutsSaveMessage("");
    setLayoutFields((current) =>
      current.map((field, currentIndex) => {
        if (currentIndex !== index) {
          return field;
        }

        if (name === "Selecionado") {
          const nextSelecionado = Number(value);
          return {
            ...field,
            Selecionado: nextSelecionado,
            Obrigatorio: nextSelecionado === 0 ? 0 : field.Obrigatorio,
          };
        }

        if (name === "Obrigatorio") {
          const nextObrigatorio = Number(value);
          return {
            ...field,
            Obrigatorio: nextObrigatorio,
            Selecionado: nextObrigatorio === 1 ? 1 : field.Selecionado,
          };
        }

        return {
          ...field,
          [name]: value,
        };
      })
    );
  };

  const handlePrintRequestFormChange = (event) => {
    const { name, value } = event.target;
    setPrintSubmitError("");
    setPrintSubmitMessage("");
    setPrintRequestForm((current) => {
      const nextForm = {
        ...current,
        [name]: value,
      };

      if (name === "DtFabricacao") {
        const selectedProduct = printProducts.find((item) => item.IdProduto === Number(nextForm.IdProduto));
        const shelfLife = Number(selectedProduct?.ShelfLife || 0);
        if (nextForm.DtFabricacao) {
          nextForm.DtValidade = addDaysToDateValue(nextForm.DtFabricacao, shelfLife);
        } else {
          nextForm.DtValidade = "";
        }
      }

      if (name === "IdProduto") {
        const selectedProduct = printProducts.find((item) => item.IdProduto === Number(value));
        const shelfLife = Number(selectedProduct?.ShelfLife || 0);
        if (current.DtFabricacao) {
          nextForm.DtValidade = addDaysToDateValue(current.DtFabricacao, shelfLife);
        }
      }

      if (name === "DtValidade") {
        nextForm.DtValidade = value;
      }

      return nextForm;
    });
  };

  const handlePrintHistoryFilterChange = (event) => {
    const { name, value } = event.target;
    setPrintHistoryActionError("");
    setPrintHistoryActionMessage("");
    setPrintHistoryFilterForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleCreditHistoryFilterChange = (event) => {
    const { name, value } = event.target;
    setCreditHistoryError("");
    setCreditHistoryFilter((current) => ({ ...current, [name]: value }));
  };

  const handleCreditHistorySearch = () => {
    if (creditHistoryFilter.DataInicial && creditHistoryFilter.DataFinal && creditHistoryFilter.DataInicial > creditHistoryFilter.DataFinal) {
      setCreditHistoryError("A data inicial não pode ser maior que a data final.");
      return;
    }

    loadCreditHistory();
  };

  const handleCreditRechargeFormChange = (event) => {
    const { name, value } = event.target;
    setCreditRechargeError("");
    setCreditRechargeMessage("");
    setCreditRechargeForm((current) => ({ ...current, [name]: value }));
  };

  const handleCreditRechargeSubmit = async (event) => {
    event.preventDefault();
    setCreditRechargeError("");
    setCreditRechargeMessage("");

    if (!isProtectedAdmin || !authUser?.JwtToken) {
      setCreditRechargeError("Você não tem permissão para recarregar créditos.");
      return;
    }

    const quantity = Number(creditRechargeForm.QtdeCredito);
    if (creditRechargeForm.QtdeCredito === "" || !Number.isInteger(quantity) || quantity <= 0) {
      setCreditRechargeError("QtdeCredito deve ser maior que zero.");
      return;
    }

    if (!window.confirm(`Confirma a recarga de ${quantity.toLocaleString("pt-BR")} créditos?`)) {
      return;
    }

    setCreditRechargeSubmitting(true);

    try {
      const { response, payload } = await postJson(
        "/api/Credit/Recharge",
        {
          QtdeCredito: quantity,
          Observacao: creditRechargeForm.Observacao.trim() || null,
        },
        authUser.JwtToken
      );
      const responseSource = getApiSource(payload);
      const idCreditoHistorico = Number(pickValue(responseSource, "IdCreditoHistorico", "idCreditoHistorico", 0));
      const responseMessage = pickValue(responseSource, "Mensagem", "mensagem", "");

      if (!response.ok || idCreditoHistorico <= 0) {
        setCreditRechargeError(
          responseMessage || (response.status === 403
            ? "Você não tem permissão para recarregar créditos."
            : "Não foi possível realizar a recarga de créditos.")
        );
        return;
      }

      setCreditRechargeMessage(responseMessage || "Crédito recarregado com sucesso.");
      setCreditRechargeForm(DEFAULT_CREDIT_RECHARGE_FORM);
      await Promise.all([loadCreditBalance(), loadCreditHistory()]);
    } catch (error) {
      setCreditRechargeError("Não foi possível realizar a recarga de créditos.");
    } finally {
      setCreditRechargeSubmitting(false);
    }
  };

  const handleTenantFilterChange = (event) => {
    const { name, value } = event.target;
    setTenantFilterForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleTenantFormChange = (event) => {
    const { name, value } = event.target;
    setTenantSaveError("");
    setTenantSaveMessage("");
    setTenantForm((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleLoginSubmit = async (event) => {
    event.preventDefault();
    setLoginError("");

    if (!loginForm.Login.trim() || !loginForm.Senha.trim()) {
      setLoginError("Login e senha sao obrigatorios.");
      return;
    }

    setIsLoginSubmitting(true);

    try {
      const { response, payload } = await postJson("/api/User/Login", {
        Login: loginForm.Login.trim(),
        Senha: loginForm.Senha,
      });

      const normalized = normalizeAuthResponse(payload);

      if (!response.ok || !normalized || !normalized.JwtToken) {
        setLoginError(normalized?.Mensagem || "Nao foi possivel autenticar o usuario.");
        return;
      }

      if (normalized.IsBlocked === 1) {
        setLoginError(normalized.Mensagem || "Usuario bloqueado.");
        return;
      }

      if (normalized.CdStatus !== 1) {
        setLoginError(normalized.Mensagem || "Usuario inativo.");
        return;
      }

      const stored = saveAuthSession(normalized);
      setAuthUser(stored);
      await loadActiveTenant(stored?.JwtToken || null);
      setUsers([]);
      setUsersLoaded(false);
      setProducts([]);
      setProductsLoaded(false);
      setClients([]);
      setClientsLoaded(false);
      setPrinters([]);
      setPrintersLoaded(false);
      setLayouts([]);
      setLayoutsLoaded(false);
      setPrintProducts([]);
      setPrintPrinters([]);
      setPrintLayouts([]);
      setPrintOptionsLoaded(false);
      setPrintHistoryItems([]);
      setPrintHistoryLoaded(false);
      setTenants([]);
      setTenantLoaded(false);
      setTermsError("");
      setTermsHtml("");
      setHasAcceptedTerms(false);
      setCreditBalance(null);
      setCreditBalanceError("");
      setCreditHistory([]);
      setCreditHistoryError("");
      setCreditHistoryFilter(DEFAULT_CREDIT_HISTORY_FILTER);
      setCreditHistoryLoaded(false);
      setCreditRechargeForm(DEFAULT_CREDIT_RECHARGE_FORM);
      setCreditRechargeError("");
      setCreditRechargeMessage("");
      setLoginForm((current) => ({ ...current, Senha: "" }));
      window.location.hash = "/dashboard";
    } catch (error) {
      setLoginError("Falha ao realizar o login.");
    } finally {
      setIsLoginSubmitting(false);
    }
  };

  const handleLogout = () => {
    clearAuthSession();
    setAuthUser(null);
    setUsers([]);
    setUsersLoaded(false);
    setProducts([]);
    setProductsLoaded(false);
    setClients([]);
    setClientsLoaded(false);
    setPrinters([]);
    setPrintersLoaded(false);
    setLayouts([]);
    setLayoutsLoaded(false);
    setUserForm(DEFAULT_USER_FORM);
    setUserFilterForm(DEFAULT_USER_FILTER);
    setProductForm(DEFAULT_PRODUCT_FORM);
    setProductFilterForm(DEFAULT_PRODUCT_FILTER);
    setClientForm(DEFAULT_CLIENT_FORM);
    setClientFilterForm(DEFAULT_CLIENT_FILTER);
    setPrinterForm(DEFAULT_PRINTER_FORM);
    setPrinterFilterForm(DEFAULT_PRINTER_FILTER);
    setLayoutForm(DEFAULT_LAYOUT_FORM);
    setLayoutFilterForm(DEFAULT_LAYOUT_FILTER);
    setLayoutFields(buildLayoutFields());
    setLoginForm({ Login: "", Senha: "" });
    setLoginError("");
    setTermsError("");
    setTermsHtml("");
    setHasAcceptedTerms(false);
    setCreditBalance(null);
    setCreditBalanceError("");
    setCreditHistory([]);
    setCreditHistoryError("");
    setCreditHistoryFilter(DEFAULT_CREDIT_HISTORY_FILTER);
    setCreditHistoryLoaded(false);
    setCreditRechargeForm(DEFAULT_CREDIT_RECHARGE_FORM);
    setCreditRechargeSubmitting(false);
    setCreditRechargeError("");
    setCreditRechargeMessage("");
    setUsersListError("");
    setUsersSaveError("");
    setUsersSaveMessage("");
    setProductsListError("");
    setProductsSaveError("");
    setProductsSaveMessage("");
    setClientsListError("");
    setClientsSaveError("");
    setClientsSaveMessage("");
    setPrintersListError("");
    setPrintersSaveError("");
    setPrintersSaveMessage("");
    setLayoutsListError("");
    setLayoutsSaveError("");
    setLayoutsSaveMessage("");
    setPrintRequestForm(DEFAULT_PRINT_REQUEST_FORM);
    setPrintProducts([]);
    setPrintPrinters([]);
    setPrintLayouts([]);
    setPrintOptionsLoaded(false);
    setPrintOptionsError("");
    setPrintSubmitError("");
    setPrintSubmitMessage("");
    setLastPrintResult(null);
    setPrintHistoryFilterForm(DEFAULT_PRINT_HISTORY_FILTER);
    setPrintHistoryItems([]);
    setPrintHistoryLoaded(false);
    setPrintHistoryListError("");
    setPrintHistoryActionError("");
    setPrintHistoryActionMessage("");
    setTenantFilterForm(DEFAULT_TENANT_FILTER);
    setTenantForm(DEFAULT_TENANT_FORM);
    setTenants([]);
    setTenantLoaded(false);
    setTenantListError("");
    setTenantSaveError("");
    setTenantSaveMessage("");
    window.location.hash = "/dashboard";
  };

  const handleAcceptTerms = async () => {
    if (!authUser?.JwtToken) {
      setTermsError("Sessao invalida para registrar o aceite do termo.");
      return;
    }

    setTermsError("");
    setIsTermsSubmitting(true);

    try {
      const { response, payload } = await postJson(
        "/api/User/AcceptTerms",
        {},
        authUser.JwtToken
      );

      const newToken = pickValue(getApiSource(payload), "JwtToken", "jwtToken", "");
      if (!response.ok || !newToken) {
        setTermsError(pickValue(payload, "Mensagem", "mensagem", "Nao foi possivel registrar o aceite do termo."));
        return;
      }

      const updatedSession = saveAuthSession({
        ...authUser,
        TermsUse: 1,
        DtAceiteTermo: pickValue(payload, "DtAceiteTermo", "dtAceiteTermo", authUser.DtAceiteTermo),
        JwtToken: newToken,
      });

      setAuthUser(updatedSession);
      setHasAcceptedTerms(false);
      window.location.hash = "/dashboard";
    } catch (error) {
      setTermsError("Falha ao registrar o aceite do termo.");
    } finally {
      setIsTermsSubmitting(false);
    }
  };

  const handleOpenCreateUser = () => {
    setUsersSaveError("");
    setUsersSaveMessage("");
    setUserForm(DEFAULT_USER_FORM);
  };

  const handleEditUser = (user) => {
    setUsersSaveError("");
    setUsersSaveMessage("");
    setUserForm({
      IdUsuario: user.IdUsuario,
      Login: user.Login,
      Senha: "",
      IsAdmin: resolveFlag(user.IsAdmin),
      IsBlocked: resolveFlag(user.IsBlocked),
      CdStatus: Number(user.CdStatus || 0),
      TermsUse: resolveFlag(user.TermsUse),
    });
  };

  const handleOpenCreateProduct = () => {
    setProductsSaveError("");
    setProductsSaveMessage("");
    setProductForm(DEFAULT_PRODUCT_FORM);
  };

  const handleCopyProduct = () => {
    if (productsLoading || productsSaving) {
      return;
    }

    setProductsSaveError("");
    setProductsSaveMessage("");

    if (productNutritionLoading || productNutritionSaving) {
      setProductsSaveError("Aguarde a operação de valores nutricionais terminar antes de copiar.");
      return;
    }

    if (!authUser?.JwtToken) {
      setProductsSaveError("Sessão expirada. Entre novamente para copiar o produto.");
      return;
    }

    if (Number(productForm.IdProduto || 0) <= 0) {
      setProductsSaveError("Selecione um produto existente para copiar.");
      return;
    }

    // A cópia prepara um novo formulário. Nada é salvo neste momento.
    setProductForm((current) => ({
      ...current,
      IdProduto: 0,
      // Identificadores do novo produto devem ser informados pelo usuário.
      CodigoExterno: "",
      CodigoBaseProduto: "",
      CodBarras: "",
    }));

    // Não reaproveitar no novo cadastro a tabela nutricional do produto original.
    setIsProductNutritionOpen(false);
    setProductNutritionItems([]);
    setProductNutritionError("");
    setProductNutritionMessage("");

    setProductsSaveMessage(
      "Dados copiados para um novo cadastro, ainda não salvo. Informe o SKU e o EAN do novo produto, revise os demais campos e clique em Salvar produto. O código ERP foi limpo e a tabela de valores nutricionais não foi copiada."
    );
  };

  const handleEditProduct = (product) => {
    setProductsSaveError("");
    setProductsSaveMessage("");
    setProductForm({
      IdProduto: product.IdProduto,
      CodigoExterno: product.CodigoExterno,
      CodigoBaseProduto: product.CodigoBaseProduto,
      CodBarras: product.CodBarras,
      TipoCodigo: product.TipoCodigo || 1,
      Descricao: product.Descricao,
      ShelfLife: product.ShelfLife || "",
      IdTipoProduto: product.IdTipoProduto || "",
      Peso: product.Peso ?? "",
      PrecoVenda: product.PrecoVenda ?? "",
      MarcaProduto: product.MarcaProduto,
      UnidadeMedida: product.UnidadeMedida || "",
      PorcaoNutricional: product.PorcaoNutricional || "",
      ContemGluten: product.ContemGluten ?? "",
      Ingredientes: product.Ingredientes || "",
      CdStatus: product.CdStatus || 1,
    });
  };

  const handleOpenProductNutrition = async () => {
    const idProduto = Number(productForm.IdProduto || 0);

    if (!authUser?.JwtToken || idProduto <= 0) {
      return;
    }

    setIsProductNutritionOpen(true);
    setProductNutritionItems([]);
    setProductNutritionError("");
    setProductNutritionMessage("");
    setProductNutritionLoading(true);

    try {
      const { response, payload } = await postJson(
        "/api/ProductNutrition/Get",
        { IdProduto: idProduto },
        authUser.JwtToken
      );
      const normalized = normalizeProductNutritionDto(payload);

      if (!response.ok || normalized.IdProduto <= 0) {
        setProductNutritionError(normalized.Mensagem || "Nao foi possivel carregar os valores nutricionais.");
        return;
      }

      setProductNutritionItems(normalized.Itens);
    } catch (error) {
      setProductNutritionError("Falha ao carregar os valores nutricionais.");
    } finally {
      setProductNutritionLoading(false);
    }
  };

  const handleProductNutritionItemChange = (index, field, value) => {
    setProductNutritionError("");
    setProductNutritionMessage("");
    setProductNutritionItems((current) => current.map((item, itemIndex) => (
      itemIndex === index ? { ...item, [field]: value } : item
    )));
  };

  const handleAddProductNutritionItem = () => {
    setProductNutritionError("");
    setProductNutritionMessage("");
    setProductNutritionItems((current) => [...current, createEmptyProductNutritionItem()]);
  };

  const handleRemoveProductNutritionItem = (index) => {
    setProductNutritionError("");
    setProductNutritionMessage("");
    setProductNutritionItems((current) => current.filter((_, itemIndex) => itemIndex !== index));
  };

  const handleCancelProductNutrition = () => {
    setIsProductNutritionOpen(false);
    setProductNutritionItems([]);
    setProductNutritionError("");
    setProductNutritionMessage("");
  };

  const handleSaveProductNutrition = async () => {
    const idProduto = Number(productForm.IdProduto || 0);

    if (!authUser?.JwtToken || idProduto <= 0) {
      setProductNutritionError("Salve o produto antes de cadastrar os valores nutricionais.");
      return;
    }

    setProductNutritionError("");
    setProductNutritionMessage("");

    const validation = validateProductNutritionItems(productNutritionItems);

    if (validation.error) {
      setProductNutritionError(validation.error);
      return;
    }

    setProductNutritionItems(validation.normalizedItems);

    setProductNutritionSaving(true);

    try {
      const { response, payload } = await postJson(
        "/api/ProductNutrition/Save",
        {
          IdProduto: idProduto,
          Itens: validation.normalizedItems,
        },
        authUser.JwtToken
      );
      const normalized = normalizeProductNutritionDto(payload);

      if (!response.ok || normalized.IdProduto <= 0) {
        setProductNutritionError(normalized.Mensagem || "Nao foi possivel salvar os valores nutricionais.");
        return;
      }

      setProductNutritionItems(normalized.Itens);
      setProductNutritionMessage(normalized.Mensagem || "Valores nutricionais salvos com sucesso.");
    } catch (error) {
      setProductNutritionError("Falha ao salvar os valores nutricionais.");
    } finally {
      setProductNutritionSaving(false);
    }
  };

  const handleOpenCreateClient = () => {
    setClientsSaveError("");
    setClientsSaveMessage("");
    setClientForm(DEFAULT_CLIENT_FORM);
  };

  const handleEditClient = (client) => {
    setClientsSaveError("");
    setClientsSaveMessage("");
    setClientForm({
      IdCliente: client.IdCliente,
      CNPJ: client.CNPJ,
      RazaoSocial: client.RazaoSocial,
      NomeFantasia: client.NomeFantasia,
      EnderecoCompleto: client.EnderecoCompleto,
      CdStatus: client.CdStatus || 1,
    });
  };

  const handleOpenCreatePrinter = () => {
    setPrintersSaveError("");
    setPrintersSaveMessage("");
    setPrinterForm(DEFAULT_PRINTER_FORM);
  };

  const handleEditPrinter = (printer) => {
    setPrintersSaveError("");
    setPrintersSaveMessage("");
    setPrinterForm({
      IdImpressora: printer.IdImpressora,
      CodigoImpressora: printer.CodigoImpressora,
      NomeRede: printer.NomeRede,
      NomeComputadorRede: printer.NomeComputadorRede,
      Marca: printer.Marca,
      Modelo: printer.Modelo,
      Apelido: printer.Apelido,
      CdStatus: printer.CdStatus || 1,
    });
  };

  const handleOpenCreateLayout = () => {
    setLayoutsSaveError("");
    setLayoutsSaveMessage("");
    setLayoutForm(DEFAULT_LAYOUT_FORM);
    setLayoutFields(buildLayoutFields());
  };

  const handleCopyLayout = () => {
    if (layoutsLoading || layoutsSaving) {
      return;
    }

    setLayoutsSaveError("");
    setLayoutsSaveMessage("");

    if (!authUser?.JwtToken) {
      setLayoutsSaveError("Sessão expirada. Entre novamente para copiar a etiqueta.");
      return;
    }

    if (Number(layoutForm.IdLayoutImpressao || 0) <= 0) {
      setLayoutsSaveError("Selecione um layout existente para copiar.");
      return;
    }

    // Prepara um novo cadastro sem alterar o layout original.
    setLayoutForm((current) => ({
      ...current,
      IdLayoutImpressao: 0,
      CodigoLayout: "",
    }));

    // Copia cada campo, mas remove os IDs dos vínculos com o layout original.
    // IdCampoImpressao permanece: ele identifica o campo no catálogo.
    setLayoutFields((current) =>
      current.map((field) => ({
        ...field,
        IdLayoutImpressaoXCampos: 0,
        IdLayoutImpressao: 0,
      }))
    );

    setLayoutsSaveMessage(
      "Dados copiados para uma nova etiqueta, ainda não salva. Informe um novo Código do Layout, revise os dados e os campos e clique em Salvar layout."
    );
  };

  const handleEditLayout = async (layout) => {
    setLayoutsSaveError("");
    setLayoutsSaveMessage("");

    if (!authUser?.JwtToken || !layout?.IdLayoutImpressao) {
      setLayoutsSaveError("Sessao invalida para carregar o layout.");
      return;
    }

    setLayoutsLoading(true);

    try {
      const { response, payload } = await postJson(
        "/api/PrintLayout/FilterPrintLayout",
        {
          IdLayoutImpressao: Number(layout.IdLayoutImpressao),
        },
        authUser.JwtToken
      );

      if (!response.ok || !Array.isArray(payload) || payload.length === 0) {
        setLayoutsSaveError("Nao foi possivel carregar o layout selecionado.");
        return;
      }

      const normalized = normalizeLayoutDto(payload[0]);
      setLayoutForm({
        IdLayoutImpressao: normalized.IdLayoutImpressao,
        CodigoLayout: normalized.CodigoLayout,
        Descricao: normalized.Descricao,
        QtdeColunasImpressao: normalized.QtdeColunasImpressao,
        Altura: normalized.Altura ?? "",
        Largura: normalized.Largura ?? "",
        ZPL: normalized.ZPL,
        CdStatus: normalized.CdStatus || 1,
      });
      setLayoutFields(buildLayoutFields(normalized.Campos, normalized.IdLayoutImpressao));
    } catch (error) {
      setLayoutsSaveError("Falha ao carregar o layout.");
    } finally {
      setLayoutsLoading(false);
    }
  };

  const handleUserSubmit = async (event) => {
    event.preventDefault();
    setUsersSaveError("");
    setUsersSaveMessage("");

    if (!authUser?.JwtToken) {
      setUsersSaveError("Sessao expirada para salvar usuario.");
      return;
    }

    if (!userForm.Login.trim()) {
      setUsersSaveError("Login obrigatorio.");
      return;
    }

    if (!isEditingUser && !userForm.Senha.trim()) {
      setUsersSaveError("Senha obrigatoria para criar usuario.");
      return;
    }

    if (
      isSelectAll(userForm.IsAdmin) ||
      isSelectAll(userForm.IsBlocked) ||
      isSelectAll(userForm.CdStatus) ||
      isSelectAll(userForm.TermsUse)
    ) {
      setUsersSaveError("Selecione valores válidos para Administrador, Bloqueado, Status e Termos de Uso antes de salvar.");
      return;
    }

    setUsersSaving(true);

    try {
      const requestBody = {
        IdUsuario: isEditingUser ? Number(userForm.IdUsuario) : 0,
        Login: userForm.Login.trim(),
        IsAdmin: Number(userForm.IsAdmin),
        IsBlocked: Number(userForm.IsBlocked),
        CdStatus: Number(userForm.CdStatus),
        TermsUse: Number(userForm.TermsUse),
      };

      if (!isEditingUser) {
        requestBody.Senha = userForm.Senha;
      }

      const { response, payload } = await postJson("/api/User/InsertUpdateUser", requestBody, authUser.JwtToken);
      const normalizedUser = normalizeUserDto(payload);
      if (!response.ok || normalizedUser.IdUsuario <= 0) {
        setUsersSaveError(pickValue(payload, "Mensagem", "mensagem", "Nao foi possivel salvar o usuario."));
        return;
      }

      setUsersSaveMessage(isEditingUser ? "Usuario atualizado com sucesso." : "Usuario criado com sucesso.");
      setUserForm(DEFAULT_USER_FORM);
      await loadUsers();
    } catch (error) {
      setUsersSaveError("Falha ao salvar o usuario.");
    } finally {
      setUsersSaving(false);
    }
  };

  const handleProductSubmit = async (event) => {
    event.preventDefault();
    setProductsSaveError("");
    setProductsSaveMessage("");

    if (!authUser?.JwtToken) {
      setProductsSaveError("Sessao expirada para salvar produto.");
      return;
    }

    if (!productForm.CodigoBaseProduto.trim() || !productForm.CodBarras.trim() || !productForm.Descricao.trim()) {
      setProductsSaveError("CodigoBaseProduto, CodBarras e Descricao sao obrigatorios.");
      return;
    }

    if (!productForm.ShelfLife || !productForm.IdTipoProduto) {
      setProductsSaveError("Tempo para vencimento e classificação são Obrigatórios.");
      return;
    }

    if (isSelectAll(productForm.IdTipoProduto) || isSelectAll(productForm.CdStatus)) {
      setProductsSaveError("Selecione valores válidos para Classificação e Status antes de salvar.");
      return;
    }

    setProductsSaving(true);

    try {
      const requestBody = {
        IdProduto: isEditingProduct ? Number(productForm.IdProduto) : 0,
        CodigoExterno: productForm.CodigoExterno.trim() || null,
        CodigoBaseProduto: productForm.CodigoBaseProduto.trim(),
        CodBarras: productForm.CodBarras.trim(),
        TipoCodigo: Number(productForm.TipoCodigo || 1),
        Descricao: productForm.Descricao.trim(),
        ShelfLife: Number(productForm.ShelfLife),
        IdTipoProduto: Number(productForm.IdTipoProduto),
        Peso: toNullableDecimal(productForm.Peso),
        PrecoVenda: toNullableDecimal(productForm.PrecoVenda),
        MarcaProduto: productForm.MarcaProduto.trim() || null,
        UnidadeMedida: productForm.UnidadeMedida.trim() || null,
        PorcaoNutricional: productForm.PorcaoNutricional.trim() || null,
        ContemGluten: productForm.ContemGluten === "" ? null : Number(productForm.ContemGluten),
        Ingredientes: productForm.Ingredientes.trim() || null,
        CdStatus: Number(productForm.CdStatus),
      };

      const { response, payload } = await postJson("/api/Product/InsertUpdateProduct", requestBody, authUser.JwtToken);
      const normalizedProduct = normalizeProductDto(payload);
      if (!response.ok || normalizedProduct.IdProduto <= 0) {
        setProductsSaveError(pickValue(payload, "Mensagem", "mensagem", "Nao foi possivel salvar o produto."));
        return;
      }

      setProductsSaveMessage(isEditingProduct ? "Produto atualizado com sucesso." : "Produto criado com sucesso.");
      setProductForm({
        IdProduto: normalizedProduct.IdProduto,
        CodigoExterno: normalizedProduct.CodigoExterno || "",
        CodigoBaseProduto: normalizedProduct.CodigoBaseProduto || "",
        CodBarras: normalizedProduct.CodBarras || "",
        TipoCodigo: normalizedProduct.TipoCodigo || 1,
        Descricao: normalizedProduct.Descricao || "",
        ShelfLife: normalizedProduct.ShelfLife || "",
        IdTipoProduto: normalizedProduct.IdTipoProduto || "",
        Peso: normalizedProduct.Peso ?? "",
        PrecoVenda: normalizedProduct.PrecoVenda ?? "",
        MarcaProduto: normalizedProduct.MarcaProduto || "",
        UnidadeMedida: normalizedProduct.UnidadeMedida || "",
        PorcaoNutricional: normalizedProduct.PorcaoNutricional || "",
        ContemGluten: normalizedProduct.ContemGluten ?? "",
        Ingredientes: normalizedProduct.Ingredientes || "",
        CdStatus: normalizedProduct.CdStatus || 1,
      });
      await loadProducts();
    } catch (error) {
      setProductsSaveError("Falha ao salvar o produto.");
    } finally {
      setProductsSaving(false);
    }
  };

  const handleClientSubmit = async (event) => {
    event.preventDefault();
    setClientsSaveError("");
    setClientsSaveMessage("");

    if (!authUser?.JwtToken) {
      setClientsSaveError("Sessao expirada para salvar cliente.");
      return;
    }

    if (isSelectAll(clientForm.CdStatus)) {
      setClientsSaveError("Selecione um status válido antes de salvar.");
      return;
    }

    setClientsSaving(true);

    try {
      const requestBody = {
        IdCliente: isEditingClient ? Number(clientForm.IdCliente) : 0,
        CNPJ: clientForm.CNPJ.trim() || null,
        RazaoSocial: clientForm.RazaoSocial.trim() || null,
        NomeFantasia: clientForm.NomeFantasia.trim() || null,
        EnderecoCompleto: clientForm.EnderecoCompleto.trim() || null,
        CdStatus: Number(clientForm.CdStatus),
      };

      const { response, payload } = await postJson("/api/Client/InsertUpdateClient", requestBody, authUser.JwtToken);
      const normalizedClient = normalizeClientDto(payload);
      if (!response.ok || normalizedClient.IdCliente <= 0) {
        setClientsSaveError(pickValue(payload, "Mensagem", "mensagem", "Nao foi possivel salvar o cliente."));
        return;
      }

      setClientsSaveMessage(isEditingClient ? "Cliente atualizado com sucesso." : "Cliente criado com sucesso.");
      setClientForm(DEFAULT_CLIENT_FORM);
      await loadClients();
    } catch (error) {
      setClientsSaveError("Falha ao salvar o cliente.");
    } finally {
      setClientsSaving(false);
    }
  };

  const handlePrinterSubmit = async (event) => {
    event.preventDefault();
    setPrintersSaveError("");
    setPrintersSaveMessage("");

    if (!authUser?.JwtToken) {
      setPrintersSaveError("Sessao expirada para salvar impressora.");
      return;
    }

    if (
      !printerForm.CodigoImpressora.trim() ||
      !printerForm.NomeRede.trim() ||
      !printerForm.NomeComputadorRede.trim() ||
      !printerForm.Marca.trim() ||
      !printerForm.Modelo.trim() ||
      !printerForm.Apelido.trim()
    ) {
      setPrintersSaveError("Código da impressora, nome da rede, nome do computador na rede, marca, modelo e apelido são Obrigatórios.");
      return;
    }

    if (isSelectAll(printerForm.CdStatus)) {
      setPrintersSaveError("Selecione um status válido antes de salvar.");
      return;
    }

    setPrintersSaving(true);

    try {
      const requestBody = {
        IdImpressora: isEditingPrinter ? Number(printerForm.IdImpressora) : 0,
        CodigoImpressora: printerForm.CodigoImpressora.trim(),
        NomeRede: printerForm.NomeRede.trim(),
        NomeComputadorRede: printerForm.NomeComputadorRede.trim(),
        Marca: printerForm.Marca.trim(),
        Modelo: printerForm.Modelo.trim(),
        Apelido: printerForm.Apelido.trim(),
        CdStatus: Number(printerForm.CdStatus),
      };

      const { response, payload } = await postJson("/api/Printer/InsertUpdatePrinter", requestBody, authUser.JwtToken);
      const normalizedPrinter = normalizePrinterDto(payload);
      if (!response.ok || normalizedPrinter.IdImpressora <= 0) {
        setPrintersSaveError(pickValue(payload, "Mensagem", "mensagem", "Nao foi possivel salvar a impressora."));
        return;
      }

      setPrintersSaveMessage(isEditingPrinter ? "Impressora atualizada com sucesso." : "Impressora criada com sucesso.");
      setPrinterForm(DEFAULT_PRINTER_FORM);
      await loadPrinters();
    } catch (error) {
      setPrintersSaveError("Falha ao salvar a impressora.");
    } finally {
      setPrintersSaving(false);
    }
  };

  const handleLayoutSubmit = async (event) => {
    event.preventDefault();
    setLayoutsSaveError("");
    setLayoutsSaveMessage("");

    if (!authUser?.JwtToken) {
      setLayoutsSaveError("Sessao expirada para salvar layout.");
      return;
    }

    if (!layoutForm.CodigoLayout.trim() || !layoutForm.Descricao.trim() || !layoutForm.ZPL.trim()) {
      setLayoutsSaveError("CodigoLayout, Descricao e ZPL sao obrigatorios.");
      return;
    }

    if (!layoutForm.QtdeColunasImpressao || Number(layoutForm.QtdeColunasImpressao) <= 0) {
      setLayoutsSaveError("QtdeColunasImpressao deve ser maior que zero.");
      return;
    }

    if (isSelectAll(layoutForm.CdStatus)) {
      setLayoutsSaveError("Selecione um status válido antes de salvar.");
      return;
    }

    setLayoutsSaving(true);

    try {
      const layoutRequest = {
        IdLayoutImpressao: isEditingLayout ? Number(layoutForm.IdLayoutImpressao) : 0,
        CodigoLayout: layoutForm.CodigoLayout.trim(),
        Descricao: layoutForm.Descricao.trim(),
        QtdeColunasImpressao: Number(layoutForm.QtdeColunasImpressao),
        Altura: toNullableDecimal(layoutForm.Altura),
        Largura: toNullableDecimal(layoutForm.Largura),
        ZPL: layoutForm.ZPL,
        CdStatus: Number(layoutForm.CdStatus),
      };

      const { response, payload } = await postJson("/api/PrintLayout/InsertUpdatePrintLayout", layoutRequest, authUser.JwtToken);
      const normalizedLayout = normalizeLayoutDto(payload);
      if (!response.ok || normalizedLayout.IdLayoutImpressao <= 0) {
        setLayoutsSaveError(pickValue(payload, "Mensagem", "mensagem", "Nao foi possivel salvar o layout."));
        return;
      }

      const idLayoutImpressao = Number(normalizedLayout.IdLayoutImpressao);
      const fieldsRequest = {
        IdLayoutImpressao: idLayoutImpressao,
        Campos: layoutFields.map((field) => ({
          IdLayoutImpressaoXCampos: field.IdLayoutImpressaoXCampos > 0 ? Number(field.IdLayoutImpressaoXCampos) : 0,
          IdLayoutImpressao: idLayoutImpressao,
          IdCampoImpressao: Number(field.IdCampoImpressao),
          Obrigatorio: resolveFlag(field.Obrigatorio),
          Selecionado: resolveFlag(field.Selecionado),
          OrdemExibicao: field.OrdemExibicao === "" ? null : Number(field.OrdemExibicao),
        })),
      };

      const fieldResponse = await postJson("/api/PrintLayout/SavePrintLayoutFields", fieldsRequest, authUser.JwtToken);
      if (!fieldResponse.response.ok || !Array.isArray(fieldResponse.payload)) {
        setLayoutsSaveError("Layout salvo, mas nao foi possivel salvar os campos vinculados.");
        return;
      }

      setLayoutsSaveMessage(isEditingLayout ? "Layout atualizado com sucesso." : "Layout criado com sucesso.");
      setLayoutForm(DEFAULT_LAYOUT_FORM);
      setLayoutFields(buildLayoutFields());
      await loadLayouts();
    } catch (error) {
      setLayoutsSaveError("Falha ao salvar o layout.");
    } finally {
      setLayoutsSaving(false);
    }
  };

  const handlePrintRequestSubmit = async (event) => {
    event.preventDefault();
    setPrintSubmitError("");
    setPrintSubmitMessage("");

    if (!authUser?.JwtToken) {
      setPrintSubmitError("Sessao expirada para enviar a impressao.");
      return;
    }

    if (!printRequestForm.IdProduto || !printRequestForm.IdLayoutImpressao || !printRequestForm.IdImpressora) {
      setPrintSubmitError("Produto, Layout e Impressora sao obrigatorios.");
      return;
    }

    if (!printRequestForm.QtdeRequerida || Number(printRequestForm.QtdeRequerida) <= 0) {
      setPrintSubmitError("QtdeRequerida deve ser maior que zero.");
      return;
    }

    setPrintSubmitting(true);

    try {
      const requestBody = {
        IdProduto: Number(printRequestForm.IdProduto),
        IdLayoutImpressao: Number(printRequestForm.IdLayoutImpressao),
        IdImpressora: Number(printRequestForm.IdImpressora),
        CodLote: printRequestForm.CodLote.trim() || null,
        DtFabricacao: toTimestampValue(printRequestForm.DtFabricacao),
        DtValidade: toTimestampValue(printRequestForm.DtValidade),
        QtdeRequerida: Number(printRequestForm.QtdeRequerida),
      };

      const { response, payload } = await postJson("/api/PrintManagement/SendPrint", requestBody, authUser.JwtToken);
      const normalized = normalizePrintManagementDto(payload);

      if (!response.ok || normalized.IdImpressao <= 0) {
        setPrintSubmitError(
          normalized.MensagemErro || pickValue(payload, "MensagemErro", "mensagemErro", "Não foi possível enviar a Solicitação de Impressão.")
        );
        setLastPrintResult(normalized);
        await loadCreditBalance();
        return;
      }

      setLastPrintResult(normalized);
      setPrintSubmitMessage("Solicitacao de impressao enviada com sucesso.");
      setPrintRequestForm(DEFAULT_PRINT_REQUEST_FORM);
      await loadDashboard();
      await loadCreditBalance();
    } catch (error) {
      setPrintSubmitError("Falha ao enviar a Solicitação de Impressão.");
    } finally {
      setPrintSubmitting(false);
    }
  };

  const handleReprint = async (item) => {
    setPrintHistoryActionError("");
    setPrintHistoryActionMessage("");

    if (!authUser?.JwtToken) {
      setPrintHistoryActionError("Sessao expirada para reimprimir.");
      return;
    }

    if (!item?.IdImpressao) {
      setPrintHistoryActionError("Selecione uma Solicitação válida para reImpressão.");
      return;
    }

    setPrintHistoryReprinting(true);

    try {
      const requestBody = {
        IdImpressao: Number(item.IdImpressao),
        IdImpressora: Number(item.IdImpressora),
        IdLayoutImpressao: Number(item.IdLayoutImpressao),
        IdProduto: Number(item.IdProduto),
        CodLote: item.CodLote || null,
        DtFabricacao: item.DtFabricacao || null,
        DtValidade: item.DtValidade || null,
        QtdeRequerida: Number(item.QtdeRequerida || 0),
      };

      const { response, payload } = await postJson("/api/PrintManagement/Reprint", requestBody, authUser.JwtToken);
      const normalized = normalizePrintManagementDto(payload);

      if (!response.ok || normalized.IdImpressao <= 0) {
        setPrintHistoryActionError(
          normalized.MensagemErro || pickValue(payload, "MensagemErro", "mensagemErro", "Nao foi possivel solicitar a reimpressao.")
        );
        await loadCreditBalance();
        return;
      }

      setPrintHistoryActionMessage(`Reimpressão solicitada para a Solicitação ${normalized.IdImpressao}.`);
      await loadPrintHistory();
      await loadDashboard();
      await loadCreditBalance();
      await loadCreditHistory();
    } catch (error) {
      setPrintHistoryActionError("Falha ao solicitar a reimpressao.");
    } finally {
      setPrintHistoryReprinting(false);
    }
  };

  const handleEditTenant = (tenant) => {
    setTenantSaveError("");
    setTenantSaveMessage("");
    setTenantForm({
      IdTenant: tenant.IdTenant || 0,
      NomeFantasia: tenant.NomeFantasia || "",
      RazaoSocial: tenant.RazaoSocial || "",
      CNPJ: tenant.CNPJ || "",
      NomeArquivoLogo: tenant.NomeArquivoLogo || "",
      CorPrincipal: tenant.CorPrincipal || DEFAULT_PRIMARY_COLOR,
      CorDestaque: tenant.CorDestaque || DEFAULT_ACCENT_COLOR,
      CdStatus: tenant.CdStatus || 1,
    });
  };

  const handleTenantSubmit = async (event) => {
    event.preventDefault();
    setTenantSaveError("");
    setTenantSaveMessage("");

    if (!authUser?.JwtToken || authUser?.IsAdmin !== 1) {
      setTenantSaveError("Sessao invalida para salvar tenant.");
      return;
    }

    if (isSelectAll(tenantForm.CdStatus)) {
      setTenantSaveError("Selecione um status válido antes de salvar.");
      return;
    }

    setTenantSaving(true);

    try {
      const currentTenant = tenants[0] || activeTenant || null;
      const requestBody = {
        IdTenant: Number(tenantForm.IdTenant || currentTenant?.IdTenant || 0),
        NomeFantasia: tenantForm.NomeFantasia.trim() || null,
        RazaoSocial: tenantForm.RazaoSocial.trim() || null,
        CNPJ: tenantForm.CNPJ.trim() || null,
        NomeArquivoLogo: tenantForm.NomeArquivoLogo.trim() || null,
        CorPrincipal: tenantForm.CorPrincipal.trim() || null,
        CorDestaque: tenantForm.CorDestaque.trim() || null,
        CdStatus: Number(tenantForm.CdStatus),
      };

      const { response, payload } = await postJson("/api/Tenant/InsertUpdateTenant", requestBody, authUser.JwtToken);
      const normalized = normalizeTenantDto(payload);

      if (!response.ok || normalized.IdTenant <= 0) {
        setTenantSaveError(normalized.Mensagem || pickValue(payload, "Mensagem", "mensagem", "Nao foi possivel salvar o tenant."));
        return;
      }

      setTenantSaveMessage("Tenant salvo com sucesso.");
      setTenantForm({
        IdTenant: normalized.IdTenant,
        NomeFantasia: normalized.NomeFantasia,
        RazaoSocial: normalized.RazaoSocial,
        CNPJ: normalized.CNPJ,
        NomeArquivoLogo: normalized.NomeArquivoLogo,
        CorPrincipal: normalized.CorPrincipal || DEFAULT_PRIMARY_COLOR,
        CorDestaque: normalized.CorDestaque || DEFAULT_ACCENT_COLOR,
        CdStatus: normalized.CdStatus || 1,
      });

      if (normalized.CdStatus === 1) {
        const savedTenant = saveTenantTheme(normalized);
        setActiveTenant(savedTenant);
      } else {
        await loadActiveTenant(authUser.JwtToken);
      }

      await loadTenant();
    } catch (error) {
      setTenantSaveError("Falha ao salvar a configuracao.");
    } finally {
      setTenantSaving(false);
    }
  };

  const visibleDashboardItems = dashboardItems.filter((item) => ![4, 5].includes(Number(item.CdStatus || 0)));
  const sortedDashboardItems = [...visibleDashboardItems].sort(
    (left, right) => getDashboardSortTimestamp(right) - getDashboardSortTimestamp(left)
  );
  const dashboardPrintedCount = sumPrintQuantity(visibleDashboardItems, (item) => item.QtdeImpressa);
  const dashboardPendingCount = visibleDashboardItems.reduce((total, item) => {
    const status = Number(item.CdStatus || 0);
    if (status !== 1 && status !== 3) {
      return total;
    }

    const requested = Number(item.QtdeRequerida || 0);
    const printed = Number(item.QtdeImpressa || 0);
    return total + Math.max(requested - printed, 0);
  }, 0);
  const dashboardRecentItems = sortedDashboardItems.slice(0, DASHBOARD_RECENT_LIMIT);
  const dashboardMetrics = [
    { value: String(dashboardPendingCount), label: "pendentes" },
    { value: String(dashboardPrintedCount), label: "impressas" },
    { value: creditBalance?.SaldoCredito ?? "Indisponível", label: "Créditos disponíveis" },
  ];

  const renderRouteContent = () => {
    if (activeRoute === "usuarios") {
      return (
        <UsersScreen
          authUser={authUser}
          users={users}
          filterForm={userFilterForm}
          userForm={userForm}
          isLoading={usersLoading}
          isSaving={usersSaving}
          listError={usersListError}
          saveError={usersSaveError}
          saveMessage={usersSaveMessage}
          isEditing={isEditingUser}
          onFilterChange={handleUserFilterChange}
          onSearch={() => loadUsers(userForm)}
          onOpenCreate={handleOpenCreateUser}
          onEdit={handleEditUser}
          onFormChange={handleUserFormChange}
          onSubmit={handleUserSubmit}
          onCancel={handleOpenCreateUser}
        />
      );
    }

    if (activeRoute === "produtos") {
      return (
        <>
          <ProductsScreen
            authUser={authUser}
            products={products}
            productTypes={productTypes}
            filterForm={productFilterForm}
            productForm={productForm}
            isLoading={productsLoading}
            isSaving={productsSaving}
            listError={productsListError}
            saveError={productsSaveError}
            saveMessage={productsSaveMessage}
            isEditing={isEditingProduct}
            onFilterChange={handleProductFilterChange}
            onSearch={() => loadProducts(productForm)}
            onOpenCreate={handleOpenCreateProduct}
            onEdit={handleEditProduct}
            onCopy={handleCopyProduct}
            onFormChange={handleProductFormChange}
            onSubmit={handleProductSubmit}
            onCancel={handleOpenCreateProduct}
            onOpenNutrition={handleOpenProductNutrition}
          />
          <ProductNutritionModal
            isOpen={isProductNutritionOpen}
            productName={productForm.Descricao}
            items={productNutritionItems}
            isLoading={productNutritionLoading}
            isSaving={productNutritionSaving}
            error={productNutritionError}
            message={productNutritionMessage}
            onAdd={handleAddProductNutritionItem}
            onChange={handleProductNutritionItemChange}
            onRemove={handleRemoveProductNutritionItem}
            onCancel={handleCancelProductNutrition}
            onSave={handleSaveProductNutrition}
          />
        </>
      );
    }

    if (activeRoute === "clientes") {
      return (
        <ClientsScreen
          authUser={authUser}
          clients={clients}
          filterForm={clientFilterForm}
          clientForm={clientForm}
          isLoading={clientsLoading}
          isSaving={clientsSaving}
          listError={clientsListError}
          saveError={clientsSaveError}
          saveMessage={clientsSaveMessage}
          isEditing={isEditingClient}
          onFilterChange={handleClientFilterChange}
          onSearch={() => loadClients(clientForm)}
          onOpenCreate={handleOpenCreateClient}
          onEdit={handleEditClient}
          onFormChange={handleClientFormChange}
          onSubmit={handleClientSubmit}
          onCancel={handleOpenCreateClient}
        />
      );
    }

    if (activeRoute === "impressoras") {
      return (
        <PrintersScreen
          authUser={authUser}
          printers={printers}
          filterForm={printerFilterForm}
          printerForm={printerForm}
          isLoading={printersLoading}
          isSaving={printersSaving}
          listError={printersListError}
          saveError={printersSaveError}
          saveMessage={printersSaveMessage}
          isEditing={isEditingPrinter}
          onFilterChange={handlePrinterFilterChange}
          onSearch={() => loadPrinters(printerForm)}
          onOpenCreate={handleOpenCreatePrinter}
          onEdit={handleEditPrinter}
          onFormChange={handlePrinterFormChange}
          onSubmit={handlePrinterSubmit}
          onCancel={handleOpenCreatePrinter}
        />
      );
    }

    if (activeRoute === "layouts") {
      return (
        <LayoutsScreen
          authUser={authUser}
          layouts={layouts}
          activePrintFields={activePrintFields}
          filterForm={layoutFilterForm}
          layoutForm={layoutForm}
          layoutFields={layoutFields}
          isLoading={layoutsLoading}
          isSaving={layoutsSaving}
          listError={layoutsListError}
          saveError={layoutsSaveError}
          saveMessage={layoutsSaveMessage}
          isEditing={isEditingLayout}
          onFilterChange={handleLayoutFilterChange}
          onSearch={() => loadLayouts(layoutForm)}
          onOpenCreate={handleOpenCreateLayout}
          onEdit={handleEditLayout}
          onCopy={handleCopyLayout}
          onFormChange={handleLayoutFormChange}
          onFieldChange={handleLayoutFieldChange}
          onSubmit={handleLayoutSubmit}
          onCancel={handleOpenCreateLayout}
        />
      );
    }

    if (activeRoute === "impressao") {
      return (
        <PrintManagementScreen
          authUser={authUser}
          printRequestForm={printRequestForm}
          products={printProducts}
          activeClients={activeClients}
          layouts={printLayouts}
          printers={printPrinters}
          productTypes={productTypes}
          activePrintFields={activePrintFields}
          isOptionsLoading={printOptionsLoading}
          isSubmitting={printSubmitting}
          optionsError={printOptionsError}
          submitError={printSubmitError}
          submitMessage={printSubmitMessage}
          lastResult={lastPrintResult}
          creditBalance={creditBalance}
          creditBalanceLoading={creditBalanceLoading}
          creditBalanceError={creditBalanceError}
          onFormChange={handlePrintRequestFormChange}
          onRefreshOptions={loadPrintOptions}
          onSubmit={handlePrintRequestSubmit}
          onReset={() => {
            setPrintSubmitError("");
            setPrintSubmitMessage("");
            setPrintRequestForm(DEFAULT_PRINT_REQUEST_FORM);
            setLastPrintResult(null);
          }}
          onRecharge={() => setIsCreditRechargeDialogOpen(true)}
        />
      );
    }

    if (activeRoute === "historico") {
      return (
        <PrintHistoryScreen
          authUser={authUser}
          filterForm={printHistoryFilterForm}
          historyItems={printHistoryItems}
          products={printProducts}
          printers={printPrinters}
          layouts={printLayouts}
          isLoading={printHistoryLoading}
          isReprinting={printHistoryReprinting}
          listError={printHistoryListError}
          actionError={printHistoryActionError}
          actionMessage={printHistoryActionMessage}
          onFilterChange={handlePrintHistoryFilterChange}
          onSearch={() => loadPrintHistory()}
          onReprint={handleReprint}
          onRecharge={() => setIsCreditRechargeDialogOpen(true)}
        />
      );
    }

    if (activeRoute === "creditos") {
      return (
        <CreditScreen
          creditBalance={creditBalance}
          creditBalanceLoading={creditBalanceLoading}
          creditBalanceError={creditBalanceError}
          creditHistory={creditHistory}
          creditHistoryLoading={creditHistoryLoading}
          creditHistoryError={creditHistoryError}
          creditHistoryFilter={creditHistoryFilter}
          onFilterChange={handleCreditHistoryFilterChange}
          onSearch={handleCreditHistorySearch}
          onClearFilters={() => {
            setCreditHistoryFilter(DEFAULT_CREDIT_HISTORY_FILTER);
            setCreditHistory([]);
            setCreditHistoryError("");
            setCreditHistoryLoaded(false);
          }}
          onRecharge={() => setIsCreditRechargeDialogOpen(true)}
        />
      );
    }

    if (activeRoute === "recarga-creditos" && isProtectedAdmin) {
      return (
        <CreditRechargeAdminScreen
          creditBalance={creditBalance}
          creditBalanceLoading={creditBalanceLoading}
          creditBalanceError={creditBalanceError}
          form={creditRechargeForm}
          isSubmitting={creditRechargeSubmitting}
          error={creditRechargeError}
          message={creditRechargeMessage}
          onFormChange={handleCreditRechargeFormChange}
          onSubmit={handleCreditRechargeSubmit}
        />
      );
    }

    if (activeRoute === "tenant" && authUser?.IsAdmin === 1) {
      return (
        <TenantScreen
          authUser={authUser}
          tenants={tenants}
          filterForm={tenantFilterForm}
          tenantForm={tenantForm}
          isLoading={tenantLoading}
          isSaving={tenantSaving}
          listError={tenantListError}
          saveError={tenantSaveError}
          saveMessage={tenantSaveMessage}
          singletonWarning={tenantSingletonWarning}
          onFilterChange={handleTenantFilterChange}
          onSearch={() => loadTenant()}
          onEdit={handleEditTenant}
          onFormChange={handleTenantFormChange}
          onSubmit={handleTenantSubmit}
          onReset={() => {
            setTenantSaveError("");
            setTenantSaveMessage("");
            if (tenants[0]) {
              handleEditTenant(tenants[0]);
              return;
            }

            setTenantForm(DEFAULT_TENANT_FORM);
          }}
        />
      );
    }

    return (
      <>
        <section className="dashboard-toolbar">
          <div>
            <span className="hero-eyebrow">Visao geral operacional</span>
            <h2>Dashboard</h2>
          </div>

          <button className="secondary-button compact" type="button" onClick={refreshDashboard} disabled={dashboardLoading || creditBalanceLoading}>
            {dashboardLoading ? "Atualizando..." : "Atualizar dashboard"}
          </button>
        </section>

        <section className="metrics-grid">
          {dashboardMetrics.map((metric) => (
            <article key={metric.label} className="metric-card">
              <strong>{metric.value}</strong>
              <span>{metric.label}</span>
            </article>
          ))}
        </section>

        {creditBalanceError ? <div className="feedback error">{creditBalanceError}</div> : null}
        <section className="credit-dashboard-card">
          <div>
            <span>Créditos disponíveis</span>
            <strong>{creditBalanceLoading ? "Carregando..." : creditBalance?.SaldoCredito ?? "Indisponível"}</strong>
          </div>
          <CreditRechargeActions compact onOpen={() => setIsCreditRechargeDialogOpen(true)} />
        </section>
        <CreditLowBalanceWarning creditBalance={creditBalance} onRecharge={() => setIsCreditRechargeDialogOpen(true)} />

        <section className="details-grid">
          <article className="content-card">
            <div className="section-heading">
              <span>Fila oficial</span>
              <h2>Ultimas geracoes validas</h2>
            </div>

            {dashboardError ? <div className="feedback error">{dashboardError}</div> : null}

            <div className="stack-list">
              {dashboardLoading ? <div className="stack-row">Carregando indicadores...</div> : null}

              {!dashboardLoading && dashboardRecentItems.length === 0 ? (
                <div className="stack-row">
                  <div>
                    <strong>Nenhuma Impressão encontrada</strong>
                    <small>Sem dados para exibir no momento.</small>
                  </div>
                  <span className="status-chip neutral">Vazio</span>
                </div>
              ) : null}

              {!dashboardLoading
                ? dashboardRecentItems.map((item) => (
                  <div key={item.IdImpressao} className="stack-row">
                    <div>
                      <strong>{getDashboardPrintTitle(item)}</strong>
                      <small>
                        Requisição: {formatTimestampLabel(item.DataRequisicao)} | Impressora:{" "}
                        {item.NomeRede || item.NomeComputadorRede || "Não informada"}
                      </small>
                    </div>
                    <span className={`status-chip ${getDashboardStatusTone(item.CdStatus)}`}>
                      {getPrintStatusLabel(item.CdStatus)}
                    </span>
                  </div>
                ))
                : null}
            </div>
          </article>

          <article className="content-card">
            <div className="section-heading">
              <span>Resumo</span>
              <h2>Resumo operacional</h2>
            </div>

            <div className="stack-list">
              <div className="stack-row action-row">
                <div>
                  <strong>Pendentes na fila</strong>
                  <small>Solicitacoes aguardando atendimento.</small>
                </div>
                <span className="status-chip warning">{dashboardPendingCount}</span>
              </div>

              <div className="stack-row action-row">
                <div>
                  <strong>Impressas com sucesso</strong>
                  <small>Solicitacoes concluídas com sucesso.</small>
                </div>
                <span className="status-chip success">{dashboardPrintedCount}</span>
              </div>

              <div className="stack-row action-row">
                <div>
                  <strong>Ultimas impressoes</strong>
                  <small>Resumo das movimentacoes mais recentes.</small>
                </div>
                <span className="status-chip neutral">{dashboardRecentItems.length}</span>
              </div>
            </div>
          </article>
        </section>
      </>
    );
  };

  if (!authUser?.JwtToken) {
    return (
      <LoginView
        loginForm={loginForm}
        isSubmitting={isLoginSubmitting}
        loginError={loginError}
        onChange={handleLoginFieldChange}
        onSubmit={handleLoginSubmit}
        tenantName={tenantName}
        tenantLogoUrl={tenantLogoUrl}
        tenantInitials={tenantInitials}
        showPassword={loginShowPassword}
        onTogglePassword={handleToggleLoginPassword}
      />
    );
  }

  if (resolveFlag(authUser.TermsUse) !== 1) {
    return (
      <TermsModal
        authUser={authUser}
        termsHtml={termsHtml}
        isLoading={isTermsLoading}
        isSubmitting={isTermsSubmitting}
        termsError={termsError}
        hasAccepted={hasAcceptedTerms}
        onAcceptanceChange={setHasAcceptedTerms}
        onAccept={handleAcceptTerms}
        onLogout={handleLogout}
      />
    );
  }

  return (
    <div className="app-shell">
      <div className="background-orb background-orb-left" />
      <div className="background-orb background-orb-right" />

      <main className="layout-grid">
        <aside className="sidebar-panel">
          <div className="brand-block sidebar-brand">
            <BrandLogo logoUrl={tenantLogoUrl} initials={tenantInitials} alt={`${tenantName} logo`} />
            <div>
              <span className="brand-kicker">{tenantName}</span>
              <strong className="brand-title">{tenantSocialReason}</strong>
              <span className="brand-subtitle">Operacao central de etiquetas</span>
            </div>
          </div>

          <div className="operator-card">
            <div className="operator-avatar">{authUser.Login.slice(0, 2).toUpperCase()}</div>
            <div className="operator-copy">
              <strong>{authUser.Login}</strong>
              <span>{subtitle}</span>
            </div>
            <span className="operator-dot" aria-hidden="true" />
          </div>

          <div className="sidebar-header">
            <span className="sidebar-label">Menu</span>
            <h2>Modulos</h2>
          </div>

          <nav className="menu-list" aria-label={`Modulos do ${tenantName}`}>
            {visibleRoutes.map((route) => {
              const isActive = route.key === activeScreen.key;

              return (
                <button
                  key={route.key}
                  type="button"
                  className={`menu-item${isActive ? " active" : ""}`}
                  onClick={() => {
                    window.location.hash = `/${route.key}`;
                  }}
                >
                  <span className="nav-icon" aria-hidden="true">{route.abbrev}</span>
                  <span className="nav-copy">
                    <span className="nav-title">{route.label}</span>
                    <small className="nav-hint">{route.navHint}</small>
                  </span>
                </button>
              );
            })}
          </nav>

          <div className="sidebar-footer">
            <CreditRechargeActions compact onOpen={() => setIsCreditRechargeDialogOpen(true)} />
            <button className="secondary-button compact" type="button" onClick={handleLogout}>
              Sair
            </button>
          </div>
        </aside>

        <section className="content-area">
          <section className="hero-panel">
            <div className="hero-copy">
              <span className="hero-eyebrow">{activeScreen.eyebrow}</span>
              <h1>{activeScreen.title}</h1>
            </div>
            <ProductLogoMark className="product-hero-logo" />
          </section>

          {renderRouteContent()}
        </section>
      </main>
      <CreditRechargeDialog isOpen={isCreditRechargeDialogOpen} onClose={() => setIsCreditRechargeDialogOpen(false)} />
    </div>
  );
}


